export const Features = {
    // Hero Section
    hero: {
        title: {
            en: "Dr. Guilherme Galvão",
            pt: "Dr. Guilherme Galvão"
        },
        subtitle: {
            en: "Pain treatment with an integrative approach.",
            pt: "Tratamento da dor com uma abordagem integrativa."
        },
        description: {
            en: "Pain doesn't have to be part of your routine.",
            pt: "A dor não precisa fazer parte da sua rotina."
        },
        bookSessionButton: {
            en: "Book your session",
            pt: "Marque já sua sessão"
        },
        learnMoreButton: {
            en: "Learn More",
            pt: "Saiba Mais"
        },
        servicesButton: {
            en: "Our Services",
            pt: "Nossos Serviços"
        },
        appointmentForm: {
            title: {
                en: "Schedule your Appointment",
                pt: "Agendar Consulta"
            },
            personalInfo: {
                en: "Personal Information",
                pt: "Informações Pessoais"
            },
            appointmentDetails: {
                en: "Appointment Details",
                pt: "Detalhes da Consulta"
            },
            nameLabel: {
                en: "Name/Surname",
                pt: "Nome/Apelido"
            },
            emailLabel: {
                en: "Email",
                pt: "Email"
            },
            phoneLabel: {
                en: "Phone",
                pt: "Telefone"
            },
            nextButton: {
                en: "Next",
                pt: "Próximo"
            },
            preferredDateLabel: {
                en: "Preferred Date",
                pt: "Data Preferida"
            },
            departmentLabel: {
                en: "Department",
                pt: "Departamento"
            },
            specialistLabel: {
                en: "Specialist",
                pt: "Especialista"
            },
            selectSpecialist: {
                en: "Select a specialist",
                pt: "Selecione um especialista"
            },
            backButton: {
                en: "Back",
                pt: "Voltar"
            },
            scheduleNowButton: {
                en: "Schedule Now",
                pt: "Agendar Agora"
            },
            processingText: {
                en: "Processing...",
                pt: "Processando..."
            },
            contactConfirmation: {
                en: "We will contact you to confirm your appointment",
                pt: "Entraremos em contato para confirmar a sua consulta"
            },
            successMessage: {
                title: {
                    en: "Request Sent!",
                    pt: "Solicitação Enviada!"
                },
                description: {
                    en: "We will contact you soon to confirm your appointment.",
                    pt: "Entraremos em contato em breve para confirmar sua consulta."
                },
                makeAnotherAppointment: {
                    en: "Make Another Appointment",
                    pt: "Fazer Outra Marcação"
                }
            },
            services: {
                osteopathy: {
                    en: "Osteopathy",
                    pt: "Osteopatia"
                },
                physiotherapy: {
                    en: "Physiotherapy",
                    pt: "Fisioterapia"
                },
                chiropractic: {
                    en: "Chiropractic",
                    pt: "Quiropraxia"
                },
                sportsMassage: {
                    en: "Sports Massage",
                    pt: "Massagem Desportiva"
                }
            },
            specialists: {
                guilhermeGalvao: {
                    en: "Dr. Guilherme Galvão",
                    pt: "Dr. Guilherme Galvão"
                }
            }
        }
    },
    
    // About Section
    about: {
        title: {
            en: "A new concept in pain treatment",
            pt: "Um novo conceito no tratamento da dor"
        },
        description: {
            en: "The main objective of the clinic, through the services provided, is to help the body fight pain, whether of inflammatory or traumatic origin, as well as pain of emotional origin. Living under constant stress implies the weakening of our immune system, thus causing diseases.",
            pt: "O principal objetivo da clínica, através dos serviços prestados é ajudar o organismo a combater a dor, seja ela de origem inflamatória ou traumática, bem como as dores de origem emocional. A maneira de viver sob stress constante implica a debilitação do nosso sistema imunológico provocando assim doenças."
        },
        features: {
            integratedTreatments: {
                title: {
                    en: "Integrated treatments",
                    pt: "Tratamentos integrados"
                },
                description: {
                    en: "Associate different therapeutic techniques and concepts for better use of session time and quick relief of discomfort.",
                    pt: "Associar diferentes técnicas e conceitos terapêuticos para melhor aproveitamento do tempo de sessão e rápido alívio dos desconfortos."
                }
            },
            personalizedGuidance: {
                title: {
                    en: "Personalized guidance",
                    pt: "Orientação personalizada"
                },
                description: {
                    en: "Guide the patient on how to stay balanced after improvement, with specific rehabilitation and relaxation exercises, stretching and tips on how to minimize discomfort.",
                    pt: "Orientar o paciente em como continuar equilibrado após a melhora do quadro, sendo com exercícios específicos de reabilitação e relaxamento, alongamentos e dicas de como minimizar os desconfortos."
                }
            },
            holisticApproach: {
                title: {
                    en: "Holistic approach",
                    pt: "Abordagem holística"
                },
                description: {
                    en: "All this information gathered and the constant communication between the patient and the therapist will serve as a basis to better understand each person's routine, and factors that may be involved with the symptoms presented.",
                    pt: "Todas essas informações reunidas e a constante comunicação entre o paciente e o terapeuta, servirão de base para conhecer melhor a rotina de cada pessoa, e fatores que podem estar envolvidos com os sintomas apresentados."
                }
            }
        },
        quote: {
            en: "\"Finding health should be the goal of every therapist. Anyone can find disease.\" - Andrew Taylor Still, Founder of Osteopathy",
            pt: "\"Encontrar a saúde deve ser o objetivo de todo terapeuta. Qualquer um pode encontrar a doença.\" - Andrew Taylor Still, Fundador da Osteopatia"
        }
    },
    
    // Services Section
    services: {
        title: {
            en: "Our Services",
            pt: "Nossos Serviços"
        },
        subtitle: {
            en: "Learn more about our services by selecting the service you want.",
            pt: "Saiba mais sobre os nossos serviços, selecionando o serviço que pretende."
        },
        serviceItems: {
            osteopathy: {
                title: {
                    en: "Osteopathy",
                    pt: "Osteopatia"
                },
                description: {
                    en: "Manual treatment that aims to identify and treat mobility dysfunctions of tissues that can affect health status.",
                    pt: "Tratamento manual que visa identificar e tratar as disfunções de mobilidade dos tecidos que podem afetar o estado de saúde."
                }
            },
            physiotherapy: {
                title: {
                    en: "Physiotherapy",
                    pt: "Fisioterapia"
                },
                description: {
                    en: "Science that studies, diagnoses, prevents and treats functional kinetic disorders of organs and systems of the human body.",
                    pt: "Ciência que estuda, diagnostica, previne e trata os distúrbios cinéticos funcionais de órgãos e sistemas do corpo humano."
                }
            },
            chiropractic: {
                title: {
                    en: "Chiropractic",
                    pt: "Quiropraxia"
                },
                description: {
                    en: "Manual treatment focused on the diagnosis, treatment and prevention of problems of the neuro-musculoskeletal system.",
                    pt: "Tratamento manual focado no diagnóstico, tratamento e prevenção de problemas do sistema neuro-músculo-esquelético."
                }
            },
            sportsMassage: {
                title: {
                    en: "Sports Massage",
                    pt: "Massagem Desportiva"
                },
                description: {
                    en: "Specific technique for athletes that helps in muscle recovery, injury prevention and performance improvement.",
                    pt: "Técnica específica para atletas que ajuda na recuperação muscular, prevenção de lesões e melhoria do desempenho."
                }
            },
            painTreatment: {
                title: {
                    en: "Pain Treatment",
                    pt: "Tratamento da Dor"
                },
                description: {
                    en: "Multifactorial approach to combat pain of inflammatory, traumatic or emotional origin.",
                    pt: "Abordagem multifatorial para combater dores de origem inflamatória, traumática ou emocional."
                }
            },
            posturalAlignment: {
                title: {
                    en: "Postural Alignment",
                    pt: "Alinhamento Postural"
                },
                description: {
                    en: "Posture correction to prevent pain and improve quality of life, especially for those who work many hours sitting.",
                    pt: "Correção da postura para prevenir dores e melhorar a qualidade de vida, especialmente para quem trabalha muitas horas sentado."
                }
            },
            auriculotherapy: {
                title: {
                    en: "Auriculotherapy",
                    pt: "Auriculoterapia"
                },
                description: {
                    en: "Technique of traditional Chinese medicine that uses the ear to treat various conditions and promote well-being.",
                    pt: "Técnica da medicina tradicional chinesa que utiliza o pavilhão auricular para tratar diversas condições e promover bem-estar."
                }
            },
            cuppingTherapy: {
                title: {
                    en: "Cupping Therapy",
                    pt: "Ventosaterapia"
                },
                description: {
                    en: "Therapy that uses suction cups to improve blood circulation, relieve muscle pain and promote relaxation.",
                    pt: "Terapia que utiliza copos de sucção para melhorar a circulação sanguínea, aliviar dores musculares e promover relaxamento."
                }
            },
            clinicalPilates: {
                title: {
                    en: "Clinical Pilates with Equipment",
                    pt: "Pilates Clínico com Aparelhos"
                },
                description: {
                    en: "A fundamental method for pain stabilization that promotes controlled body movement, flexibility, and strengthening of muscles that support the spine.",
                    pt: "Método fundamental na estabilização da dor que promove o movimento controlado do corpo, a flexibilidade e a força de músculos que sustentam a coluna vertebral."
                }
            }
        }
    },
    
    // Doctors Section
    doctors: {
        title: {
            en: "Specialist",
            pt: "Especialista"
        },
        subtitle: {
            en: "Dedicated to your health with rigor and dedication.",
            pt: "Dedicado à sua saúde com rigor e dedicação."
        },
        doctorsList: {
            doctor1: {
                name: {
                    en: "Dr. Guilherme Galvão",
                    pt: "Dr. Guilherme Galvão"
                },
                position: {
                    en: "Specialist in Integrated Therapies",
                    pt: "Especialista em terapias integradas"
                },
                description: {
                    en: "Dedicated to the positive change of the various dimensions of body health through personalized treatments. Specialized in osteopathy, physiotherapy, and manual therapies for pain treatment and postural alignment.",
                    pt: "Dedicado à mudança positiva das várias dimensões da saúde corporal através de tratamentos personalizados. Especializado em osteopatia, fisioterapia e terapias manuais para tratamento da dor e alinhamento postural."
                },
                about: {
                    en: "The Integrated Therapies Clinic was idealized by Dr. Guilherme Galvão with the mission of offering a new approach to pain treatment — more integrated, more human. Part of our philosophy is to show that pain and disease have multifactorial causes. So, why separate techniques if it is possible to integrate them in the same session? We bring over 15 years of clinical experience and knowledge to apply, in a personalized way, the most effective solutions in each case. Our commitment is to the positive change of body health, in all its dimensions.",
                    pt: "A Clínica de Terapias Integradas foi idealizada pelo Dr. Guilherme Galvão com a missão de oferecer uma nova abordagem no tratamento da dor — mais integrada, mais humana. Parte da nossa filosofia é mostrar que a dor e a doença têm causas multifatoriais. Então, por que separar técnicas se é possível integrá-las numa só sessão? Reunimos mais de 15 anos de experiência e conhecimento clínico para aplicar, de forma personalizada, as soluções mais eficazes em cada caso. O nosso compromisso é com a mudança positiva da saúde corporal, em todas as suas dimensões."
                },
                specialties: {
                    en: [
                        "Osteopathy - Manual treatment focused on the structure and function of the body",
                        "Physiotherapy - Recovery from injuries and improved mobility",
                        "Chiropractic - Precise adjustments to relieve pain and improve function",
                        "Clinical Pilates - Rehabilitation and strengthening with specialized equipment",
                        "Kinesiology - Assessment and treatment of emotional blockages and stress"
                    ],
                    pt: [
                        "Osteopatia - Tratamento manual focado na estrutura e função do corpo",
                        "Fisioterapia - Recuperação de lesões e melhoria da mobilidade",
                        "Quiropraxia - Ajustes precisos para aliviar dores e melhorar a função",
                        "Pilates clínico - Reabilitação e fortalecimento com aparelhos especializados",
                        "Kinesiologia - Avaliação e tratamento de bloqueios emocionais e estresse"
                    ]
                },
                credentials: {
                    en: [
                        "Specialist in pain and movement"
                    ],
                    pt: [
                        "Especialista em dor e movimento"
                    ]
                },
                phone: {
                    en: "927 202 009",
                    pt: "927 202 009"
                }
            }
        }
    },
    
    // Testimonials Section
    testimonials: {
        title: {
            en: "Testimonials",
            pt: "Depoimentos"
        },
        subtitle: {
            en: "Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.",
            pt: "Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident."
        },
        testimonialsList: [
            {
                name: {
                    en: "Saul Goodman",
                    pt: "Saul Goodman"
                },
                position: {
                    en: "Ceo & Founder",
                    pt: "CEO & Fundador"
                },
                text: {
                    en: "Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.",
                    pt: "Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper."
                }
            },
            {
                name: {
                    en: "Sara Wilsson",
                    pt: "Sara Wilsson"
                },
                position: {
                    en: "Designer",
                    pt: "Designer"
                },
                text: {
                    en: "Export tempor illum tamen malis malis eram quae irure esse labore quem cillum quid cillum eram malis quorum velit fore eram velit sunt aliqua noster fugiat irure amet legam anim culpa.",
                    pt: "Export tempor illum tamen malis malis eram quae irure esse labore quem cillum quid cillum eram malis quorum velit fore eram velit sunt aliqua noster fugiat irure amet legam anim culpa."
                }
            },
            {
                name: {
                    en: "Jena Karlis",
                    pt: "Jena Karlis"
                },
                position: {
                    en: "Store Owner",
                    pt: "Proprietária de Loja"
                },
                text: {
                    en: "Enim nisi quem export duis labore cillum quae magna enim sint quorum nulla quem veniam duis minim tempor labore quem eram duis noster aute amet eram fore quis sint minim.",
                    pt: "Enim nisi quem export duis labore cillum quae magna enim sint quorum nulla quem veniam duis minim tempor labore quem eram duis noster aute amet eram fore quis sint minim."
                }
            },
            {
                name: {
                    en: "Matt Brandon",
                    pt: "Matt Brandon"
                },
                position: {
                    en: "Freelancer",
                    pt: "Freelancer"
                },
                text: {
                    en: "Fugiat enim eram quae cillum dolore dolor amet nulla culpa multos export minim fugiat minim velit minim dolor enim duis veniam ipsum anim magna sunt elit fore quem dolore labore illum veniam.",
                    pt: "Fugiat enim eram quae cillum dolore dolor amet nulla culpa multos export minim fugiat minim velit minim dolor enim duis veniam ipsum anim magna sunt elit fore quem dolore labore illum veniam."
                }
            },
            {
                name: {
                    en: "John Larson",
                    pt: "John Larson"
                },
                position: {
                    en: "Entrepreneur",
                    pt: "Empreendedor"
                },
                text: {
                    en: "Quis quorum aliqua sint quem legam fore sunt eram irure aliqua veniam tempor noster veniam enim culpa labore duis sunt culpa nulla illum cillum fugiat legam esse veniam culpa fore nisi cillum quid.",
                    pt: "Quis quorum aliqua sint quem legam fore sunt eram irure aliqua veniam tempor noster veniam enim culpa labore duis sunt culpa nulla illum cillum fugiat legam esse veniam culpa fore nisi cillum quid."
                }
            }
        ]
    },
    
    // FAQ Section
    faq: {
        title: {
            en: "Frequently Asked Questions",
            pt: "Perguntas Frequentes"
        },
        questions: [
            {
                question: {
                    en: "The things you need to know before starting",
                    pt: "O que precisa de saber antes de começar"
                },
                answer: {
                    en: "",
                    pt: ""
                }
            },
            {
                question: {
                    en: "What is Osteopathy and how can it help me?",
                    pt: "O que é a Osteopatia e como me pode ajudar?"
                },
                answer: {
                    en: "Osteopathy is a manual therapeutic approach that treats the body as a whole, seeking the cause of pain rather than just the symptoms. It is effective in treating pain in the spine, joints, headaches, digestive disorders, and even emotional issues related to muscle tension.",
                    pt: "A Osteopatia é uma abordagem terapêutica manual que trata o corpo como um todo, procurando a causa da dor e não apenas os sintomas. É eficaz no tratamento de dores na coluna, articulações, cefaleias, disfunções digestivas e até questões emocionais relacionadas com tensão muscular."
                }
            },
            {
                question: {
                    en: "Do I need a medical referral to book an appointment?",
                    pt: "Preciso de encaminhamento médico para marcar consulta?"
                },
                answer: {
                    en: "No. You can book directly with us. During the first session, a complete evaluation is performed to understand your complaints and plan the most appropriate treatment for your case.",
                    pt: "Não. Pode agendar diretamente connosco. Na primeira sessão, é realizada uma avaliação completa para compreender as suas queixas e planear o tratamento mais adequado ao seu caso."
                }
            },
            {
                question: {
                    en: "How many sessions of Osteopathy are needed?",
                    pt: "Quantas sessões de Osteopatia são necessárias?"
                },
                answer: {
                    en: "The number of sessions depends on the clinical condition of each person. On average, 3 to 6 sessions are recommended — although many people feel improvements right after the first consultations.",
                    pt: "O número de sessões depende do quadro clínico de cada pessoa. Em média, são recomendadas entre 3 a 6 sessões — embora muitas pessoas sintam melhorias logo nas primeiras consultas."
                }
            },
            {
                question: {
                    en: "Is Osteopathy safe? Are there any contraindications?",
                    pt: "A Osteopatia é segura? Tem contraindicações?"
                },
                answer: {
                    en: "Yes, it is a safe treatment when performed by qualified professionals. There are some specific contraindications, such as recent fractures or untreated serious diseases, which are always evaluated in the initial consultation.",
                    pt: "Sim, é um tratamento seguro quando realizado por profissionais qualificados. Existem algumas contraindicações específicas, como fraturas recentes ou doenças graves não tratadas, que são sempre avaliadas na consulta inicial."
                }
            },
            {
                question: {
                    en: "Does the clinic work with health insurance or only in private regime?",
                    pt: "A clínica trabalha com seguros de saúde ou apenas em regime particular?"
                },
                answer: {
                    en: "We work in private regime, but we issue receipts for eventual reimbursement, if your health insurance allows this possibility. Please confirm with your insurance company.",
                    pt: "Atendemos em regime particular, mas emitimos recibos para eventual reembolso, caso o seu seguro de saúde permita essa possibilidade. Confirme com a sua seguradora."
                }
            }
        ]
    },
    
    // Gallery Section
    gallery: {
        title: {
            en: "Gallery",
            pt: "Galeria"
        },
        subtitle: {
            en: "Get to know our space and facilities dedicated to your well-being",
            pt: "Conheça o nosso espaço e instalações dedicadas ao seu bem-estar"
        },
        imageAlt: {
            en: "Integrated Therapies Clinic",
            pt: "Clínica de Terapias Integradas"
        },
        viewFullGalleryButton: {
            en: "View Full Gallery",
            pt: "Ver Galeria Completa"
        }
    },
    
    // Consult Section
    consult: {
        title: {
            en: "We Promote the Vitality of your Body",
            pt: "Promovemos a Vitalidade do seu Corpo"
        },
        subtitle: {
            en: "Schedule your appointment",
            pt: "Marque a sua consulta"
        },
        description: {
            en: "Discover how we can help improve your quality of life through our specialized services. Our team is ready to serve you with dedication and professionalism.",
            pt: "Descubra como podemos ajudar a melhorar a sua qualidade de vida através dos nossos serviços especializados. Nossa equipe está pronta para atendê-lo com dedicação e profissionalismo."
        },
        scheduleButton: {
            en: "Schedule Appointment",
            pt: "Marcar Consulta"
        }
    },
    
    // Methodology Section (Homepage)
    methodology: {
        title: {
            en: "My Method",
            pt: "O Meu Método"
        },
        painStatement: {
            en: "You don't need to choose a type of treatment.",
            pt: "Não precisa escolher um tipo de tratamento."
        },
        description: {
            en: "Each session is personalized and combines different therapeutic approaches, such as physiotherapy, osteopathy, chiropractic, auriculotherapy and others, according to your needs.",
            pt: "Cada sessão é personalizada e combina diferentes abordagens terapêuticas, como fisioterapia, osteopatia, quiropraxia, auriculoterapia e outras, de acordo com as suas necessidades."
        },
        causeStatement: {
            en: "The goal is to identify the true origin of pain and treat it completely, not just relieve symptoms.",
            pt: "O objetivo é identificar a verdadeira origem da dor e tratá-la de forma completa, não apenas aliviar sintomas."
        },
        approach: {
            en: "This integrative approach allows faster results, more assertive treatments, and a more efficient recovery. Each session is designed in a personalized way, combining specific techniques to accelerate pain relief and restore the body's natural balance.",
            pt: "Esta abordagem integrativa permite resultados mais rápidos, tratamentos mais assertivos e uma recuperação mais eficiente. Cada sessão é pensada de forma personalizada, combinando técnicas específicas para acelerar o alívio da dor e devolver ao corpo o seu equilíbrio natural."
        },
        goal: {
            en: "The goal is clear: reduce pain in the shortest time possible, restore functionality, and prevent the problem from returning.",
            pt: "O objetivo é claro: reduzir a dor no menor tempo possível, restaurar a funcionalidade e evitar que o problema volte."
        },
        closing: {
            en: "If you're looking for more than temporary relief, here you'll find a method focused on solutions.",
            pt: "Se procura mais do que alívio temporário, aqui encontra um método focado em solução."
        }
    },

    // First Session Section (Homepage)
    firstSession: {
        title: {
            en: "What to Expect from the 1st Session",
            pt: "O que esperar da 1ª sessão"
        },
        steps: {
            evaluation: {
                title: {
                    en: "Evaluation",
                    pt: "Avaliação"
                },
                description: {
                    en: "Listening to your complaints and choosing the most appropriate therapeutic approach.",
                    pt: "Escuta das queixas e escolha da consulta terapêutica."
                }
            },
            treatment: {
                title: {
                    en: "Treatment",
                    pt: "Tratamento"
                },
                description: {
                    en: "Choosing the therapeutic approach to correct blockages and restore balance to the body so it can heal.",
                    pt: "Escolha da conduta terapêutica para corrigir bloqueios e devolver o equilíbrio ao corpo para que ele se cure."
                }
            },
            followUp: {
                title: {
                    en: "Follow-up",
                    pt: "Acompanhamento"
                },
                description: {
                    en: "Guidance on how to prevent recurrences and exercises that can help in this regard.",
                    pt: "Orientações sobre como prevenir recidivas e exercícios que podem ajudar nesse sentido."
                }
            }
        }
    },

    // Clinical Pilates Section (Homepage)
    clinicalPilates: {
        title: {
            en: "Clinical Pilates with Equipment",
            pt: "Pilates Clínico com Aparelhos"
        },
        subtitle: {
            en: "Fundamental Tool for Pain Stabilization and Recurrence Prevention",
            pt: "Ferramenta Fundamental na Estabilização da Dor e Prevenção de Recidivas"
        },
        description: {
            en: "Clinical Pilates is a fundamental method for pain stabilization as it promotes controlled body movement, works on flexibility, and strengthens the muscles that support the spine.",
            pt: "O pilates clínico é um método fundamental na estabilização da dor pois promove o movimento controlado do corpo, trabalha a flexibilidade e a força de músculos que sustentam a coluna vertebral."
        }
    },

    // About Page
    aboutPage: {
        hero: {
            title: {
                en: "About Us",
                pt: "Sobre Nós"
            }
        },
        mainContent: {
            title: {
                en: "Welcome to our clinic.",
                pt: "Bem vindo(a) à nossa clínica."
            },
            description1: {
                en: "\"A new concept in pain treatment.\"",
                pt: "\"Um novo conceito no tratamento da dor.\""
            },
            description2: {
                en: "Here we believe that pain treatment goes far beyond an isolated approach. We work with a differentiating concept, based on the integration of various therapeutic philosophies, such as physiotherapy, osteopathy, auriculotherapy, kinesiology and chiropractic. All these approaches are used in a complementary and combined way, with the aim of identifying the true origin of pain (physical and emotional) and treating it effectively and durably.",
                pt: "Aqui acreditamos que o tratamento da dor vai muito além de uma abordagem isolada. Trabalhamos com um conceito diferenciador, baseado na integração de várias filosofias terapêuticas, como a fisioterapia, osteopatia, auriculoterapia, kinesiologia e quiropraxia. Todas estas abordagens são utilizadas de forma complementar e em conjunto, com o objetivo de identificar a verdadeira origem da dor( física e emocional) e tratá-la de forma eficaz e duradoura."
            },
            description3: {
                en: "Our focus is not just to relieve symptoms, but to promote a global balance of the body. To this end, we also combine the possibility of maintenance and prevention through Clinical Pilates, helping to strengthen, correct and optimize the body's functioning in everyday life.",
                pt: "O nosso foco não é apenas aliviar sintomas, mas promover um equilíbrio global do corpo. Para isso, aliamos também a possibilidade de manutenção e prevenção através do Pilates Clínico, ajudando a fortalecer, corrigir e otimizar o funcionamento do corpo no dia a dia."
            },
            description4: {
                en: "Each person is unique — and that is how we take care of you.",
                pt: "Cada pessoa é única — e é assim que cuidamos de si."
            },
            quote: {
                text: {
                    en: "\"Finding health should be the goal of every therapist. Anyone can find disease.\"",
                    pt: "\"Encontrar a saúde deve ser o objetivo de todo terapeuta. Qualquer um pode encontrar a doença.\""
                },
                author: {
                    en: "Andrew Taylor Still",
                    pt: "Andrew Taylor Still"
                },
                title: {
                    en: "Founder of Osteopathy",
                    pt: "Fundador da Osteopatia"
                }
            },
            clinicName: {
                en: "Clinic Dr. Guilherme Galvão",
                pt: "Clínica Dr. Guilherme Galvão"
            },
            clinicTagline: {
                en: "A new concept in pain treatment",
                pt: "Um novo conceito no tratamento da dor"
            }
        },
        location: {
            title: {
                en: "Location",
                pt: "Localização"
            },
            description1: {
                en: "Our clinic is located at Avenida Eng. Duarte Pacheco 642, about 100 meters from the roundabout at the entrance/exit of the Ermesinde highway.",
                pt: "A nossa clínica está localizada na Avenida Eng. Duarte Pacheco 642, a cerca de 100 metros da rotunda da entrada/saída da auto-estrada de Ermesinde."
            },
            description2: {
                en: "In the outdoor space next to the clinic, you will easily find parking. If you use public transport, the nearest bus stop is 50 meters away. Also in the surrounding area of the clinic, you will find various services such as a gym, supermarket, stationery store, restaurants, pizzeria, gas station.",
                pt: "No espaço exterior junto à clínica vai encontrar facilmente lugar para estacionamento. Caso utilize os transportes públicos, a paragem de autocarro mais próxima fica a 50 metros. Ainda no espaço circundante da clínica, encontra vários serviços como por exemplo, um ginásio, supermercado, papelaria, restauração pizaria, bomba de gasolina."
            },
            directions: {
                en: "EXIT Ermesinde | BEFORE THE ENTRANCE OF THE HIGHWAY A3 - Towards High Maia - Santa Rita Church.",
                pt: "SAÍDA Ermesinde | ANTES DA ENTRADA DA AUTOESTRADA A3 - Sentido Alto da Maia - Igreja de Santa Rita."
            }
        },
        vitality: {
            title: {
                en: "We Promote the Vitality of your Body",
                pt: "Promovemos a Vitalidade do seu Corpo"
            },
            subtitle: {
                en: "Schedule your appointment",
                pt: "Marque a sua consulta"
            },
            description: {
                en: "Discover how we can help improve your quality of life through our specialized services. Our team is ready to serve you with dedication and professionalism.",
                pt: "Descubra como podemos ajudar a melhorar a sua qualidade de vida através dos nossos serviços especializados. Nossa equipe está pronta para atendê-lo com dedicação e profissionalismo."
            },
            scheduleButton: {
                en: "Schedule Appointment",
                pt: "Marcar Consulta"
            }
        }
    },
    
    // Gallery Page
    galleryPage: {
        hero: {
            title: {
                en: "Gallery",
                pt: "Galeria"
            }
        },
        title: {
            main: {
                en: "Gallery Clinic Dr. Guilherme Galvão",
                pt: "Galeria Clínica Dr. Guilherme Galvão"
            },
            subtitle: {
                en: "We promote the vitality of your body",
                pt: "Promovemos a vitalidade do seu corpo"
            }
        },
        imageAlt: {
            en: "Integrated Therapies Clinic",
            pt: "Clínica de Terapias Integradas"
        },
        newsletter: {
            title: {
                en: "Receive the latest news from our clinic.",
                pt: "Receba as últimas novidades da nossa clínica."
            },
            subtitle: {
                en: "We send all the news to your email",
                pt: "Enviamos todas as novidades para o seu email"
            },
            emailPlaceholder: {
                en: "Your email",
                pt: "Seu email"
            },
            termsCheckbox: {
                en: "I accept Terms and Conditions",
                pt: "Aceito Termos e Condições"
            },
            subscribeButton: {
                en: "Subscribe to newsletter",
                pt: "Subscrever newsletter"
            }
        }
    },
    
    // Location Page
    locationPage: {
        hero: {
            title: {
                en: "Location",
                pt: "Localização"
            }
        },
        howToArrive: {
            title: {
                en: "How to Arrive",
                pt: "Como Chegar"
            },
            subtitle: {
                en: "We are located at an easily accessible point in Ermesinde",
                pt: "Estamos localizados em um ponto de fácil acesso em Ermesinde"
            }
        },
        clinicInfo: {
            title: {
                en: "Clinic Dr. Guilherme Galvão",
                pt: "Clínica Dr. Guilherme Galvão"
            },
            address: {
                label: {
                    en: "Address",
                    pt: "Endereço"
                },
                value: {
                    en: "Av. Eng. Duarte Pacheco, 642\n4445-416 Ermesinde - Valongo",
                    pt: "Av. Eng. Duarte Pacheco, 642\n4445-416 Ermesinde - Valongo"
                }
            },
            openingHours: {
                label: {
                    en: "Opening Hours",
                    pt: "Horário de Funcionamento"
                },
                value: {
                    en: "Monday to Friday: 10:00h - 20:00h\nSaturday: 8:00h - 12:00h\nSunday: Closed",
                    pt: "Segunda a Sexta: 10:00h - 20:00h\nSábado: 8:00h - 12:00h\nDomingo: Encerrado"
                }
            },
            contact: {
                label: {
                    en: "Contact",
                    pt: "Contacto"
                },
                value: {
                    en: "(+351) 927 202 009\n(Call to the national mobile network)",
                    pt: "(+351) 927 202 009\n(Chamada para a rede móvel nacional)"
                }
            },
            email: {
                label: {
                    en: "Email",
                    pt: "Email"
                },
                value: {
                    en: "info@clinicaosteopatia.pt",
                    pt: "info@clinicaosteopatia.pt"
                }
            }
        },
        directions: {
            title: {
                en: "Directions",
                pt: "Indicações"
            },
            subtitle: {
                en: "How to get to our clinic",
                pt: "Como chegar à nossa clínica"
            },
            byCar: {
                title: {
                    en: "By Car",
                    pt: "De Carro"
                },
                description: {
                    en: "Our clinic is located at Avenida Eng. Duarte Pacheco 642, about 100 meters from the roundabout at the entrance/exit of the Ermesinde highway. In the outdoor space next to the clinic, you will easily find parking.",
                    pt: "A nossa clínica está localizada na Avenida Eng. Duarte Pacheco 642, a cerca de 100 metros da rotunda da entrada/saída da auto-estrada de Ermesinde. No espaço exterior junto à clínica vai encontrar facilmente lugar para estacionar."
                },
                exitInfo: {
                    en: "EXIT Ermesinde | BEFORE THE ENTRANCE OF THE HIGHWAY A3 - Towards High Maia - Santa Rita Church.",
                    pt: "SAÍDA Ermesinde | ANTES DA ENTRADA DA AUTOESTRADA A3 - Sentido Alto da Maia - Igreja de Santa Rita."
                }
            },
            byPublicTransport: {
                title: {
                    en: "By Public Transport",
                    pt: "De Transportes Públicos"
                },
                description: {
                    en: "If you use public transport, the nearest bus stop is 50 meters away.",
                    pt: "Caso utilize os transportes públicos, a paragem de autocarro mais próxima fica a 50 metros."
                }
            },
            nearbyServices: {
                title: {
                    en: "Nearby Services",
                    pt: "Serviços Próximos"
                },
                description: {
                    en: "In the surrounding area of the clinic, you will find various services such as a gym, supermarket, stationery store, restaurants, pizzeria and gas station.",
                    pt: "No espaço circundante da clínica, encontra vários serviços como por exemplo, um ginásio, supermercado, papelaria, restauração, pizzaria e bomba de gasolina."
                }
            }
        }
    },
    
    // Arbitration Page
    arbitrationPage: {
        hero: {
            title: {
                en: "Arbitration",
                pt: "Arbitragem"
            }
        },
        clinicInfo: {
            title: {
                en: "Clinic Dr. Guilherme Galvão",
                pt: "Clínica Dr. Guilherme Galvão"
            },
            subtitle: {
                en: "We promote the vitality of your body",
                pt: "Promovemos a vitalidade do seu corpo"
            },
            description: {
                en: "Our clinic offers a variety of therapeutic treatments to promote physical and mental well-being. Learn more about our team and facilities.",
                pt: "A nossa clínica oferece uma variedade de tratamentos terapêuticos para promover o seu bem-estar físico e mental. Conheça melhor a nossa equipa e as instalações que preparámos a pensar em si."
            },
            seeMoreButton: {
                en: "See more",
                pt: "Ver mais"
            }
        },
        openingHours: {
            title: {
                en: "Opening Hours",
                pt: "Horário de Funcionamento"
            },
            subtitle: {
                en: "We are available to serve you",
                pt: "Estamos disponíveis para atendê-lo"
            },
            dayLabel: {
                en: "Day",
                pt: "Dia"
            },
            timeLabel: {
                en: "Time",
                pt: "Horário"
            },
            days: {
                monday: {
                    en: "Monday",
                    pt: "Segunda"
                },
                tuesday: {
                    en: "Tuesday",
                    pt: "Terça"
                },
                wednesday: {
                    en: "Wednesday",
                    pt: "Quarta"
                },
                thursday: {
                    en: "Thursday",
                    pt: "Quinta"
                },
                friday: {
                    en: "Friday",
                    pt: "Sexta"
                },
                saturday: {
                    en: "Saturday",
                    pt: "Sábado"
                },
                sunday: {
                    en: "Sunday",
                    pt: "Domingo"
                }
            },
            hours: {
                weekdays: {
                    en: "10:00h - 20:00h",
                    pt: "10:00h - 20:00h"
                },
                saturday: {
                    en: "8:00h - 12:00h",
                    pt: "8:00h - 12:00h"
                },
                sunday: {
                    en: "Closed",
                    pt: "Encerrado"
                }
            }
        },
        contactCard: {
            title: {
                en: "Need a personalized plan?",
                pt: "Necessita de um plano personalizado?"
            },
            description: {
                en: "Our team is ready to meet your specific needs.",
                pt: "A nossa equipa está pronta para atender às suas necessidades específicas."
            },
            contactButton: {
                en: "Contact Us",
                pt: "Fale Connosco"
            }
        },
        arbitrationInfo: {
            title: {
                en: "Arbitration Information",
                pt: "Informação de Arbitragem"
            },
            introduction: {
                en: "To all our valued customers and partners, we inform:",
                pt: "A todos os nossos prezados clientes e parceiros, informamos:"
            },
            quote: {
                en: "\"In case of dispute, the consumer can resort to an Alternative Dispute Resolution Entity for consumer disputes:",
                pt: "\"Em caso de litigio o consumidor pode recorrer a uma Entidade de Resolução Alternativa de Litígios de consumo:"
            },
            centerName: {
                en: "Consumer Information and Arbitration Center of Porto",
                pt: "Centro de Informação de Consumo e Arbitragem do Porto"
            },
            address: {
                label: {
                    en: "Postal address:",
                    pt: "Endereço postal:"
                },
                value: {
                    en: "Rua Damião de Góis, 31 – Loja 6 – 4050-225 Porto",
                    pt: "Rua Damião de Góis, 31 – Loja 6 – 4050-225 Porto"
                }
            },
            phone: {
                label: {
                    en: "Tel.:",
                    pt: "Tel.:"
                },
                value: {
                    en: "225 508 349 / 225 029 791",
                    pt: "225 508 349 / 225 029 791"
                }
            },
            fax: {
                label: {
                    en: "Fax:",
                    pt: "Fax:"
                },
                value: {
                    en: "225 026 109",
                    pt: "225 026 109"
                }
            },
            email: {
                label: {
                    en: "E-mail:",
                    pt: "E-mail:"
                },
                value: {
                    en: "cicap@mail.telepac.pt",
                    pt: "cicap@mail.telepac.pt"
                }
            },
            website: {
                label: {
                    en: "Website:",
                    pt: "Website:"
                },
                value: {
                    en: "www.cicap.pt",
                    pt: "www.cicap.pt"
                }
            },
            moreInfo: {
                en: "More information at Consumer Portal www.consumidor.pt\"",
                pt: "Mais informações em Portal do Consumidor www.consumidor.pt\""
            },
            date: {
                en: "Ermesinde, November 3, 2021",
                pt: "Ermesinde, 3 de Novembro de 2021"
            }
        }
    },
    
    // Terms Page
    termsPage: {
        en: {
            introduction: "The present general terms and conditions bind Clínica Dr. Guilherme Galvão, legal entity no. 515802220, headquartered at Av. Eng. Duarte Pacheco, 642, 4445-416 Ermesinde - Valongo and individuals and legal entities (hereinafter referred to as \"User\") who wish to subscribe to access the website www.clinicaosteopatia.pt and acquire the advertised products and services.",
            readCarefully: "PLEASE READ THESE TERMS CAREFULLY BEFORE ACCESSING OR USING THE SERVICES.",
            agreement: "BY CREATING AN ACCOUNT TO SUBSCRIBE TO ACCESS to Clínica Dr. Guilherme Galvão THE USER AGREES TO THE GENERAL TERMS AND CONDITIONS OF SERVICE AND TO THE PRIVACY AND COOKIES POLICY OF Clínica Dr. Guilherme Galvão at www.clinicaosteopatia.pt.",
            sections: {
                definition: {
                    title: "Service Definition",
                    content: "Clínica Dr. Guilherme Galvão is the legitimate owner of the technological platform www.clinicaosteopatia.pt and holder of the exploitation rights over the services, developed and marketed by Dr. Guilherme Galvão."
                },
                links: {
                    title: "Links from other sites and Communication Services",
                    content1: "Any link to third-party sites is the sole responsibility of the respective site. Clínica Dr. Guilherme Galvão reserves the right to demand that any link it considers less appropriate be removed, this criterion being exclusively the responsibility of the latter.",
                    content2: "Clínica Dr. Guilherme Galvão is not obliged to monitor communication services, although it does so regularly.",
                    content3: "Clínica Dr. Guilherme Galvão reserves the right to review the materials/information placed and used in communication services and, if it so wishes, to remove them, without giving prior notice.",
                    content4: "Clínica Dr. Guilherme Galvão is not responsible for damages caused by information and contacts established directly between users. Each user should exercise the necessary caution when providing information about themselves to others.",
                    content5: "Clínica Dr. Guilherme Galvão assumes no responsibility for actions or damages resulting from misuse of communication services or from disrespect for the conditions described above.",
                    content6: "Clínica Dr. Guilherme Galvão assumes no responsibility for opinions and comments that may be conveyed by third parties on the site, and reserves the right to remove them if it considers them offensive or in violation of the law."
                },
                usage: {
                    title: "Terms of Use",
                    content1: "Clínica Dr. Guilherme Galvão reserves the right to change the conditions of access and use of services at any time, provided that it previously notifies its customers by placing a notice on the Clínica Dr. Guilherme Galvão Platform or communicating the change via e-mail.",
                    content2: "Clínica Dr. Guilherme Galvão reserves the right to decrease and/or add services to those currently available."
                },
                technical: {
                    title: "Technical and Security Conditions",
                    content1: "The User undertakes to observe all applicable legal provisions, namely, not to practice or encourage practices of illicit acts or acts offensive to good customs, such as the indiscriminate sending of unsolicited communications (spamming) in violation of the provisions of the legislation applicable to the processing of personal data and to advertising communications through automatic calling devices, and must also observe the rules for using the Service, under penalty of Clínica Dr. Guilherme Galvão suspending or deactivating access to Clínica Dr. Guilherme Galvão.",
                    content2: "Although the Clínica Dr. Guilherme Galvão website has secure areas, it cannot be held responsible for the communication of passwords, confidential codes and any sensitive information that may eventually be diverted.",
                    content3: "The User expressly acknowledges and accepts that the IP Network constitutes a public electronic communications network susceptible to use by several users, and as such, subject to computer overloads, which is why Clínica Dr. Guilherme Galvão does not guarantee the provision of the Service without interruptions, loss of information or delays.",
                    content4: "Clínica Dr. Guilherme Galvão also does not guarantee the provision of the Service in situations of unforeseeable system overload or force majeure (situations of an extraordinary or unforeseeable nature, external to Clínica Dr. Guilherme Galvão and which cannot be controlled by it).",
                    content5: "In case of interruption of access to Clínica Dr. Guilherme Galvão due to unforeseeable overload of the systems on which it is supported, Clínica Dr. Guilherme Galvão undertakes to regularize its operation as soon as possible.",
                    content6: "Clínica Dr. Guilherme Galvão reserves the right to unilaterally change the layout of Clínica Dr. Guilherme Galvão as well as its technical configurations, always with the intention of introducing improvements or complying with legal provisions, even if they result in temporary interruptions of access to it.",
                    content7: "Clínica Dr. Guilherme Galvão is free to decide to deactivate www.clinicaosteopatia.pt, however, it must communicate this intention, either publicly on the same platform, or by communication to the registered User's e-mail, seven working days before the said deactivation."
                },
                intellectual: {
                    title: "Intellectual Property",
                    content1: "All texts, illustrations, photographs, interface, layout, software, trademarks, logos and other elements of a creative or identifying nature are the intellectual property of Clínica Dr. Guilherme Galvão, so the user must use them like any other material protected by copyright (book, film, disc, etc.), being prohibited the copying, reproduction, dissemination, modification, publication or any form of exploitation, even if free of charge or private, of any content within the scope of this contract.",
                    content2: "Any violation of the previous number will be sanctioned by Clínica Dr. Guilherme Galvão with the suspension of the service and cancellation of the User's account, being the latter subject to legal action to safeguard the rights of Clínica Dr. Guilherme Galvão and its creators and collaborators and compensation for the damages suffered."
                },
                ai: {
                    title: "Use of Artificial Intelligence in Content",
                    content: "Some of the visual content on this website, in particular illustrative and ambient images, may have been created or edited using artificial intelligence tools. These images are for illustrative purposes only and may not accurately represent real spaces, products, people or situations. Information regarding products, services, prices and conditions is accurate and can be confirmed with Clínica Dr. Guilherme Galvão. This notice is provided in compliance with the transparency obligations applicable to the use of artificial intelligence."
                },
                communications: {
                    title: "Electronic Communications",
                    content1: "Without prejudice to other forms of communication provided for in these General Conditions, notifications addressed to the User that relate to the use of Clínica Dr. Guilherme Galvão, including any changes to these General Conditions, may be sent to the User's electronic mail address (\"e-mail\"), by SMS or telephone contact.",
                    content2: "The User agrees to receive all communications and/or notifications related to the use of Clínica Dr. Guilherme Galvão to the address, contact telephone number and/or electronic mail address (\"e-mail\") indicated in the registration process. At any time, you can request cancellation of the sending of these communications and/or notifications via e-mail."
                },
                transfer: {
                    title: "Assignment of contractual position",
                    content1: "It is prohibited to temporarily assign or definitively transfer to third parties, rent, lend or any other activity or similar practice, of the e-mail, username and password that are defined by the User. The User is fully responsible for the confidentiality of the access data that he submits.",
                    content2: "The User authorizes Clínica Dr. Guilherme Galvão to assign the contractual position that it assumes in this contractual relationship to any other entity, without the need for any prior communication or authorization."
                },
                privacy: {
                    title: "Privacy Policy and Processing of Personal Data",
                    content1: "The processing of the User's data is carried out in compliance with the legislation on the protection of personal data. The User's personal data are subject to automated processing and will appear in the Clínica Dr. Guilherme Galvão database.",
                    content2: "The processing of personal data is carried out in accordance with the Privacy Policy of Clínica Dr. Guilherme Galvão and which you should read carefully here: Privacy Policy.",
                    content3: "For the use of the Platform, cookies are transferred to the User's computer's hard drive in order to facilitate navigation. The use of cookies is a common practice on most websites, and the User can predefine the acceptance or not of this type of file in their browser or firewall. It is done in accordance with our Cookie Policy which you can consult here: Cookie Policy",
                    content4: "Clínica Dr. Guilherme Galvão guarantees that it will not sell the data to third parties, and the right of access, rectification and cancellation, deletion is guaranteed, under the terms of the law (of personal data protection and other applicable legislation) as explained in the Privacy Policy. At any time, the data subject may complain of any violation to the Data Protection Officer of Clínica Dr. Guilherme Galvão through the e-mail info@clinicaosteopatia.pt."
                },
                complaints: {
                    title: "Complaint",
                    content: "The User may submit his complaints to Clínica Dr. Guilherme Galvão within thirty days after becoming aware of the fact that gave rise to the complaint through the e-mail info@clinicaosteopatia.pt."
                },
                law: {
                    title: "Applicable law, forum and proof",
                    content1: "The applicable law is Portuguese law.",
                    content2: "To resolve any and all conflicts arising from any contract concluded under these general conditions, the court of the Porto district shall be competent with express waiver of any other.",
                    content3: "The parties agree that the computerized records, kept in the computer systems of Clínica Dr. Guilherme Galvão under reasonable security conditions, constitute proof of communications and records made between the parties."
                }
            },
            finalDeclaration: "The User declares to know and accept the Terms and Conditions of Access described above, as well as the Conditions of Sale, Privacy Policy and Cookies."
        },
        pt: {
            introduction: "Os presentes termos e condições gerais vinculam Clínica Dr. Guilherme Galvão, pessoa coletiva n.º 515802220, com sede na Av. Eng. Duarte Pacheco, 642, 4445-416 Ermesinde - Valongo e as pessoas singulares e coletivas (doravante designadas por \"Utilizador\") que pretendam subscrever o acesso ao sítio da internet www.clinicaosteopatia.pt e adquirir os produtos e serviços publicitados.",
            readCarefully: "POR FAVOR, LEIA ATENTAMENTE ESTES TERMOS ANTES DE ACEDER OU UTILIZAR OS SERVIÇOS.",
            agreement: "AO CRIAR UMA CONTA PARA SUBSCREVER O ACESSO ao Clínica Dr. Guilherme Galvão O UTILIZADOR CONCORDA COM OS TERMOS E CONDIÇÕES GERAIS DO SERVIÇO E COM A POLíTICA DE PRIVACIDADE E DE COOKIES DO Clínica Dr. Guilherme Galvão em www.clinicaosteopatia.pt.",
            sections: {
                definition: {
                    title: "Definição do Serviço",
                    content: "O Clínica Dr. Guilherme Galvão é o legítimo proprietário da plataforma tecnológica www.clinicaosteopatia.pt e titular dos direitos de exploração sobre os serviços, desenvolvidos e comercializados pelo Dr. Guilherme Galvão."
                },
                links: {
                    title: "Ligações a partir de outros sites e Serviços de Comunicação",
                    content1: "Qualquer ligação a sites de terceiros é da inteira responsabilidade do respetivo site. O Clínica Dr. Guilherme Galvão reserva-se o direito de exigir que seja retirada qualquer ligação que considerar menos própria, sendo este critério exclusivamente da responsabilidade desta.",
                    content2: "O Clínica Dr. Guilherme Galvão não tem a obrigação de monitorizar os serviços de comunicação, apesar de o fazer regularmente.",
                    content3: "O Clínica Dr. Guilherme Galvão reserva-se o direito de rever os materiais/informação colocados e usados nos serviços de comunicação e, se assim o entender, retirá-los, sem dar conhecimento prévio.",
                    content4: "O Clínica Dr. Guilherme Galvão não se responsabiliza por danos causados por informações e contactos estabelecidos diretamente entre utilizadores. Cada utilizador deve usar da necessária precaução quando fornece a outrem informação acerca de si próprio.",
                    content5: "O Clínica Dr. Guilherme Galvão não assume qualquer responsabilidade por ações ou danos resultantes de má utilização dos serviços de comunicação ou pelo desrespeito das condições atrás descritas.",
                    content6: "O Clínica Dr. Guilherme Galvão não assume qualquer responsabilidade por opiniões e comentários que possam ser veiculados por terceiros no site, sendo que se reserva o direito de retirar os mesmos caso os considere ofensivos ou violadores da lei."
                },
                usage: {
                    title: "Condições de Utilização",
                    content1: "O Clínica Dr. Guilherme Galvão reserva-se o direito de alterar as condições de acesso e utilização dos serviços a qualquer altura, desde que notifique previamente os seus clientes colocando um aviso na Plataforma da Clínica Dr. Guilherme Galvão ou comunicando a alteração via e-mail.",
                    content2: "O Clínica Dr. Guilherme Galvão reserva-se o direito de diminuir e/ou acrescentar serviços aos atualmente disponibilizados."
                },
                technical: {
                    title: "Condições técnicas e de Segurança",
                    content1: "O Utilizador compromete-se a observar todas as disposições legais aplicáveis, nomeadamente, a não praticar ou a fomentar a prática de atos ilícitos ou ofensivos dos bons costumes, tais como o envio indiscriminado de comunicações não solicitadas (spamming) em violação do disposto na legislação aplicável ao tratamento de dados pessoais e às comunicações publicitárias através de aparelhos de chamada automática, devendo ainda observar as regras de utilização do Serviço, sob pena de o Clínica Dr. Guilherme Galvão suspender ou desativar o acesso à Clínica Dr. Guilherme Galvão.",
                    content2: "Apesar do site do Clínica Dr. Guilherme Galvão tere áreas seguras, não se poderá responsabilizar pela comunicação de passwords, códigos confidenciais e de qualquer informação sensível que possa, eventualmente, ser desviada.",
                    content3: "O Utilizador expressamente reconhece e aceita que a Rede IP constitui uma rede pública de comunicações eletrónicas suscetível de utilização por vários utilizadores, e como tal, sujeita a sobrecargas informáticas, pelo que o Clínica Dr. Guilherme Galvão não garante a prestação do Serviço sem interrupções, perda de informação ou atrasos.",
                    content4: "O Clínica Dr. Guilherme Galvão não garante igualmente a prestação do Serviço em situações de sobrecarga imprevisível dos sistemas em que o mesmo é suportado ou de força maior (situações de natureza extraordinária ou imprevisível, exteriores ào Clínica Dr. Guilherme Galvão e que pela mesma não possam ser controladas).",
                    content5: "Em caso de interrupção do acesso ao Clínica Dr. Guilherme Galvão por razões de sobrecarga imprevisível dos sistemas em que o mesmo é suportado, o Clínica Dr. Guilherme Galvão compromete-se a regularizar o seu funcionamento com a maior brevidade possível.",
                    content6: "O Clínica Dr. Guilherme Galvão reserva-se o direito de alterar unilateralmente o layout da Clínica Dr. Guilherme Galvão assim como as configurações técnicas da mesma, sempre no intuito de introduzir melhorias ou no cumprimento de disposições legais, ainda que das mesmas resultem interrupções temporárias de acesso à mesma.",
                    content7: "O Clínica Dr. Guilherme Galvão é livre de decidir desativar a www.clinicaosteopatia.pt devendo, no entanto, comunicar essa intenção, quer publicamente na mesma plataforma, quer por comunicação para o e-mail do Utilizador registado, com sete dias úteis de antecedência sobre a referida desativação."
                },
                intellectual: {
                    title: "Propriedade Intelectual",
                    content1: "Todos os textos, ilustrações, fotografias, interface, layout, software, marcas, logótipos e demais elementos de cariz criativo ou identificativo são propriedade intelectual do Clínica Dr. Guilherme Galvão, pelo que o utilizador deverá usá-los tal como qualquer outro material protegido pelos direitos de autor (livro, filme, disco, etc.), sendo proibida a cópia, reprodução, difusão, modificação, publicação ou qualquer forma de exploração ainda que a título gratuito ou privado, de qualquer conteúdo no âmbito deste contrato.",
                    content2: "Qualquer violação ao número anterior será sancionada pelo Clínica Dr. Guilherme Galvão com a suspensão do serviço e cancelamento da conta do Utilizador, sendo este alvo de ação judicial para salvaguarda dos direitos de o Clínica Dr. Guilherme Galvão e dos seus criadores e colaboradores e ressarcimento dos danos sofridos."
                },
                ai: {
                    title: "Utilização de Inteligência Artificial em Conteúdos",
                    content: "Alguns dos conteúdos visuais apresentados neste website, nomeadamente imagens ilustrativas e de ambiente, podem ter sido criados ou editados com recurso a ferramentas de inteligência artificial. Estas imagens têm finalidade meramente ilustrativa e podem não representar com exatidão espaços, produtos, pessoas ou situações reais. As informações sobre produtos, serviços, preços e condições são reais e podem ser confirmadas junto da Clínica Dr. Guilherme Galvão. Esta indicação é prestada em cumprimento dos deveres de transparência aplicáveis à utilização de inteligência artificial."
                },
                communications: {
                    title: "Comunicações Eletrónicas",
                    content1: "Sem prejuízo de outras formas de comunicação previstas nas presentes Condições Gerais, as notificações dirigidas ao Utilizador que se relacionem com a utilização da Clínica Dr. Guilherme Galvão incluindo eventuais alterações às presentes Condições Gerais, poderão ser enviadas para o endereço de correio eletrónico (\"e-mail\") do Utilizador, por SMS ou contacto telefónico.",
                    content2: "O Utilizador aceita receber toda e qualquer comunicação e/ou notificação relacionada com a utilização da Clínica Dr. Guilherme Galvão para a morada, telefone de contacto e ou endereço de correio eletrónico (\"e-mail\") indicados no processo de registo. Em qualquer momento, pode solicitar cancelamento do envio destas comunicações e/ou notificações através de e-mail."
                },
                transfer: {
                    title: "Cedência de posição contratual",
                    content1: "É proibida a cedência temporária ou transferência definitiva a terceiros, aluguer, empréstimo ou qualquer outra atividade ou prática semelhante, do e-mail, nome de utilizador e da password que são definidos pelo Utilizador. O Utilizador é totalmente responsável pela confidencialidade dos dados de acesso que submete.",
                    content2: "O Utilizador autoriza o Clínica Dr. Guilherme Galvão a ceder a posição contratual que esta assume na presente relação contratual a qualquer outra entidade, sem necessidade de qualquer comunicação prévia ou autorização."
                },
                privacy: {
                    title: "Política de Privacidade e Tratamento de Dados Pessoais",
                    content1: "O tratamento dos dados do Utilizador é feito no cumprimento da legislação sobre a proteção de dados pessoais. Os dados pessoais do utilizador são sujeitos a tratamento automatizado e constarão na base de dados do Clínica Dr. Guilherme Galvão.",
                    content2: "O tratamento dos dados pessoais é feito de acordo com a Política de Privacidade do Clínica Dr. Guilherme Galvão e que deve ler cuidadosamente aqui: Política de Privacidade.",
                    content3: "Para a utilização da Plataforma são transferidos para o disco duro dos computadores do Utilizador cookies com o fim de facilitar a navegação. A utilização de cookies é uma prática corrente na generalidade dos sites, podendo o Utilizador predefinir a aceitação ou não deste tipo de ficheiro no seu browser ou firewall. A mesma é feita de acordo com a nossa Política de Cookies que pode consultar aqui: Política de Cookies",
                    content4: "O Clínica Dr. Guilherme Galvão garante que não venderá os dados a terceiros, sendo garantido, nos termos da lei (de proteção de dados pessoais e demais legislação aplicável) o direito de acesso, retificação e anulação, apagamento tal como explicitado na Política de Privacidade. Podendo a qualquer momento o titular dos dados reclamar de qualquer violação para o Encarregado de Proteção de Dados do Clínica Dr. Guilherme Galvão através do e-mail info@clinicaosteopatia.pt."
                },
                complaints: {
                    title: "Reclamação",
                    content: "O Utilizador poderá apresentar as suas reclamações ao Clínica Dr. Guilherme Galvão no prazo de trinta dias após o conhecimento do facto que deu origem à reclamação através do e-mail info@clinicaosteopatia.pt."
                },
                law: {
                    title: "Lei aplicável, foro e prova",
                    content1: "A lei aplicável é a lei portuguesa.",
                    content2: "Para dirimir todo e qualquer conflito emergente de qualquer contrato celebrado nos termos destas condições gerais será competente o tribunal da comarca do Porto com expressa renúncia de qualquer outro.",
                    content3: "As partes acordam que os registos informatizados, conservados nos sistemas informáticos do Clínica Dr. Guilherme Galvão em condições razoáveis de segurança, fazem prova das comunicações e registos efetuados entre as partes."
                }
            },
            finalDeclaration: "O Utilizador declara conhecer e aceitar os Termos e Condições de Acesso acima descritos, bem como as Condições de Venda, Política de Privacidade e de Cookies."
        }
    },
    
    // Privacy Policy Page
    privacyPage: {
        en: {
            title: "Privacy Policy",
            introduction: "All your personal information collected will be used to help make your visit to our site as productive and pleasant as possible.",
            dataProtection: "All personal information relating to customers, users or visitors who use www.clinicaosteopatia.pt will be processed in accordance with the Personal Data Protection Law of October 26, 1998 (Law No. 67/98).",
            collectedInfo: "The personal information collected may include your name, email, phone and/or mobile number, address, date of birth and/or others. The use of www.clinicaosteopatia.pt assumes acceptance of this Privacy Agreement. www.clinicaosteopatia.pt reserves the right to change this agreement without prior notice. Therefore, we recommend that you check our privacy policy regularly to always stay up to date.",
            advertisements: "Advertisements Like other websites, we collect and use information contained in advertisements. The information contained in the advertisements includes your IP (Internet Protocol) address, your ISP (Internet Service Provider), the browser you used when visiting our website (such as Google Chrome or Firefox), the time of your visit and which pages you visited within our website.",
            thirdPartySites: "Links to Third-Party Sites",
            thirdPartySitesContent: "www.clinicaosteopatia.pt has links to other sites, which, in our view, may contain information/tools useful to our visitors. Our privacy policy does not apply to third-party sites, so if you visit another site from ours, you should read its privacy policy. We are not responsible for the privacy policy or content present on these sites.",
            lastUpdated: "Last Updated: October 26, 1998"
        },
        pt: {
            title: "Política de Privacidade",
            introduction: "Todas as suas informações pessoais recolhidas, serão usadas para o ajudar a tornar a sua visita no nosso site o mais produtiva e agradável possível.",
            dataProtection: "Todas as informações pessoais relativas a clientes, utilizadores ou visitantes que usem www.clinicaosteopatia.pt serão tratadas em concordância com a Lei da Proteção de Dados Pessoais de 26 de outubro de 1998 (Lei n.º 67/98).",
            collectedInfo: "A informação pessoal recolhida pode incluir o seu nome, e-mail, número de telefone e/ou telemóvel, morada, data de nascimento e/ou outros. O uso da www.clinicaosteopatia.pt pressupõe a aceitação deste Acordo de privacidade. A www.clinicaosteopatia.pt reserva-se ao direito de alterar este acordo sem aviso prévio. Deste modo, recomendamos que consulte a nossa política de privacidade com regularidade de forma a estar sempre atualizado.",
            advertisements: "Os anúncios Tal como outros websites, coletamos e utilizamos informação contida nos anúncios. A informação contida nos anúncios, inclui o seu endereço IP (Internet Protocol), o seu ISP (Internet Service Provider), o browser que utilizou ao visitar o nosso website (como o Google Chrome ou o Firefox), o tempo da sua visita e que páginas visitou dentro do nosso website.",
            thirdPartySites: "Ligações a Sites de terceiros",
            thirdPartySitesContent: "A www.clinicaosteopatia.pt possui ligações para outros sites, os quais, a nosso ver, podem conter informações / ferramentas úteis para os nossos visitantes. A nossa política de privacidade não é aplicada a sites de terceiros, pelo que, caso visite outro site a partir do nosso deverá ler a política de privacidade do mesmo. Não nos responsabilizamos pela política de privacidade ou conteúdo presente nesses mesmos sites.",
            lastUpdated: "Última Atualização: 26 de outubro de 1998"
        }
    },
    
    // Service Pages
    servicePages: {
        common: {
            title: {
                en: "Services",
                pt: "Serviços"
            },
            scheduleButton: {
                en: "Schedule Appointment",
                pt: "Marcar Consulta"
            },
            firstConsultInfo: {
                en: "The first consultation includes a complete assessment and the beginning of treatment, with an approximate duration of 50 minutes.",
                pt: "A primeira consulta inclui uma avaliação completa e o início do tratamento, com duração aproximada de 50 minutos."
            },
            sessionInfo: {
                en: "Therapy sessions have an average duration of 45-50 minutes and may include different techniques according to each patient's needs.",
                pt: "As sessões de fisioterapia têm duração média de 45-50 minutos e podem incluir diferentes técnicas conforme a necessidade de cada paciente."
            }
        },
        sidebar: {
            title: {
                en: "Services",
                pt: "Serviços"
            },
            osteopathy: {
                en: "Osteopathy",
                pt: "Osteopatia"
            },
            physiotherapy: {
                en: "Physiotherapy",
                pt: "Fisioterapia"
            },
            chiropractic: {
                en: "Chiropractic",
                pt: "Quiropraxia"
            },
            sportsMassage: {
                en: "Sports Massage",
                pt: "Massagem Desportiva"
            },
            painTreatment: {
                en: "Pain Treatment",
                pt: "Tratamento da Dor"
            },
            auriculotherapy: {
                en: "Auriculotherapy",
                pt: "Auriculoterapia"
            },
            posturalAlignment: {
                en: "Postural Alignment",
                pt: "Alinhamento Postural"
            },
            cuppingTherapy: {
                en: "Cupping Therapy",
                pt: "Ventosaterapia"
            },
            clinicalPilates: {
                en: "Clinical Pilates",
                pt: "Pilates Clínico"
            }
        },
        osteopathy: {
            title: {
                en: "Osteopathy",
                pt: "Osteopatia"
            },
            description1: {
                en: "Osteopathy is a manual treatment that aims to identify and treat mobility dysfunctions of tissues that can affect health status. This therapeutic approach is based on the principle that the human body functions as an integrated unit, where all parts are interconnected.",
                pt: "A Osteopatia é um tratamento manual que visa identificar e tratar as disfunções de mobilidade dos tecidos que podem afetar o estado de saúde. Esta abordagem terapêutica baseia-se no princípio de que o corpo humano funciona como uma unidade integrada, onde todas as partes estão interligadas."
            },
            description2: {
                en: "Through specific techniques, the osteopath works to restore body balance, improving the function of the systems:",
                pt: "Através de técnicas específicas, o osteopata trabalha para restaurar o equilíbrio corporal, melhorando a função dos sistemas:"
            },
            systems: {
                musculoskeletal: {
                    en: "Musculoskeletal",
                    pt: "Musculoesquelético"
                },
                nervous: {
                    en: "Nervous",
                    pt: "Nervoso"
                },
                circulatory: {
                    en: "Circulatory",
                    pt: "Circulatório"
                },
                visceral: {
                    en: "Visceral",
                    pt: "Visceral"
                }
            },
            description3: {
                en: "Osteopathic treatment is personalized for each patient, considering not only the symptoms but also the underlying causes of the problems. In our clinic, Osteopathy is applied based on a complete assessment of the patient, always seeking the primary cause of dysfunctions to provide lasting relief of symptoms and promote integral health.",
                pt: "O tratamento osteopático é personalizado para cada paciente, considerando não apenas os sintomas, mas também as causas subjacentes dos problemas. Na nossa clínica, a Osteopatia é aplicada com base em uma avaliação completa do paciente, buscando sempre a causa primária das disfunções para proporcionar um alívio duradouro dos sintomas e promover a saúde integral."
            }
        },
        physiotherapy: {
            title: {
                en: "Physiotherapy",
                pt: "Fisioterapia"
            },
            description1: {
                en: "Physiotherapy is a health science that studies, diagnoses, prevents, and treats functional kinetic disorders of organs and systems of the human body. Using physical and natural resources, the physiotherapist works to restore functionality, promote recovery, and improve patients' quality of life.",
                pt: "A Fisioterapia é uma ciência da saúde que estuda, diagnostica, prevene e trata os distúrbios cinéticos funcionais de órgãos e sistemas do corpo humano. Utilizando recursos físicos e naturais, o fisioterapeuta trabalha para restaurar a funcionalidade, promover a recuperação e melhorar a qualidade de vida dos pacientes."
            },
            features: {
                rehabilitation: {
                    title: {
                        en: "Rehabilitation",
                        pt: "Reabilitação"
                    },
                    description: {
                        en: "Post-surgical, traumatological, and neurological recovery",
                        pt: "Recuperação pós-cirúrgica, traumatológica e neurológica"
                    }
                },
                respiratory: {
                    title: {
                        en: "Respiratory",
                        pt: "Respiratória"
                    },
                    description: {
                        en: "Treatment of respiratory conditions and improvement of lung capacity",
                        pt: "Tratamento de condições respiratórias e melhoria da capacidade pulmonar"
                    }
                },
                sports: {
                    title: {
                        en: "Sports",
                        pt: "Desportiva"
                    },
                    description: {
                        en: "Prevention and treatment of injuries related to sports practice",
                        pt: "Prevenção e tratamento de lesões relacionadas à prática esportiva"
                    }
                },
                postural: {
                    title: {
                        en: "Postural",
                        pt: "Postural"
                    },
                    description: {
                        en: "Correction of postural and ergonomic problems",
                        pt: "Correção de problemas posturais e ergonômicos"
                    }
                }
            },
            description2: {
                en: "Our physiotherapists are highly qualified professionals who use modern techniques based on scientific evidence to ensure the best results for each patient. The treatment is always individualized, considering the specific needs and goals of each person.",
                pt: "Nossos fisioterapeutas são profissionais altamente qualificados que utilizam técnicas modernas e baseadas em evidências científicas para garantir os melhores resultados para cada paciente. O tratamento é sempre individualizado, considerando as necessidades específicas e objetivos de cada pessoa."
            }
        },
        auriculotherapy: {
            title: {
                en: "Auriculotherapy",
                pt: "Auriculoterapia"
            },
            description1: {
                en: "Auriculotherapy is a technique from Traditional Chinese Medicine that uses the ear as a microsystem for diagnosing and treating various physical and emotional conditions. Based on the principle that the ear contains reflex points that correspond to all parts of the body, this therapy stimulates specific points to promote balance and well-being.",
                pt: "A Auriculoterapia é uma técnica da Medicina Tradicional Chinesa que utiliza o pavilhão auricular (orelha) como microssistema para diagnóstico e tratamento de diversas condições físicas e emocionais. Baseada no princípio de que a orelha contém pontos reflexos que correspondem a todas as partes do corpo, esta terapia estimula pontos específicos para promover equilíbrio e bem-estar."
            },
            benefitsTitle: {
                en: "Benefits of Auriculotherapy",
                pt: "Benefícios da Auriculoterapia"
            },
            benefits: {
                stressReduction: {
                    en: "Stress and Anxiety Reduction",
                    pt: "Redução do Estresse e Ansiedade"
                },
                painRelief: {
                    en: "Pain Relief",
                    pt: "Alívio de Dores"
                },
                sleepImprovement: {
                    en: "Sleep Improvement",
                    pt: "Melhoria do Sono"
                }
            },
            treatmentTitle: {
                en: "How is the treatment performed?",
                pt: "Como é realizado o tratamento?"
            },
            treatmentDescription1: {
                en: "The treatment is performed by applying seeds, spheres, or needles to specific points on the ear. These seeds or spheres are fixed with a small adhesive and remain on the ear for a few days, continuously stimulating the reflex points. The patient is instructed to press these points several times a day to enhance the therapeutic effect.",
                pt: "O tratamento é realizado através da aplicação de sementes, esferas ou agulhas em pontos específicos da orelha. Estas sementes ou esferas são fixadas com um pequeno adesivo e permanecem na orelha por alguns dias, estimulando continuamente os pontos reflexos. O paciente é orientado a pressionar estes pontos algumas vezes ao dia para potencializar o efeito terapêutico."
            },
            treatmentDescription2: {
                en: "Auriculotherapy can be used as a main treatment or as a complement to other therapies. It is a safe, non-invasive technique with few side effects, suitable for people of all ages.",
                pt: "A Auriculoterapia pode ser utilizada como tratamento principal ou como complemento a outras terapias. É uma técnica segura, não invasiva e com poucos efeitos colaterais, sendo adequada para pessoas de todas as idades."
            },
            sessionInfo: {
                en: "Auriculotherapy sessions have an average duration of 30 minutes, and the number of sessions varies according to each case and condition treated.",
                pt: "As sessões de Auriculoterapia têm duração média de 30 minutos, e o número de sessões varia de acordo com cada caso e condição tratada."
            }
        },
        chiropractic: {
            title: {
                en: "Chiropractic",
                pt: "Quiropraxia"
            },
            description1: {
                en: "Chiropractic is a therapeutic approach focused on the diagnosis, treatment, and prevention of problems of the neuro-musculoskeletal system. This manual technique aims primarily to restore proper function of the spine and nervous system, promoting health naturally, without the use of medications or surgeries.",
                pt: "A Quiropraxia é uma abordagem terapêutica focada no diagnóstico, tratamento e prevenção de problemas do sistema neuro-músculo-esquelético. Esta técnica manual tem como principal objetivo restaurar a função adequada da coluna vertebral e do sistema nervoso, promovendo a saúde de forma natural, sem o uso de medicamentos ou cirurgias."
            },
            benefitsTitle: {
                en: "Benefits of Chiropractic",
                pt: "Benefícios da Quiropraxia"
            },
            benefits: {
                backPainRelief: {
                    en: "Relief of back and neck pain",
                    pt: "Alívio de dores nas costas e pescoço"
                },
                jointMobility: {
                    en: "Improvement of joint mobility",
                    pt: "Melhoria da mobilidade articular"
                },
                posturalCorrection: {
                    en: "Postural correction",
                    pt: "Correção postural"
                },
                muscleTension: {
                    en: "Reduction of muscle tension",
                    pt: "Redução de tensões musculares"
                },
                nervousFunction: {
                    en: "Improvement of nervous function",
                    pt: "Melhoria da função nervosa"
                }
            },
            howItWorksTitle: {
                en: "How does it work?",
                pt: "Como funciona?"
            },
            howItWorksDescription: {
                en: "Chiropractors use precise adjustments to correct subluxations (vertebral misalignments) that can interfere with the proper transmission of nerve impulses, affecting the overall health of the body. These adjustments help relieve pain, improve mobility, and restore normal function of the nervous system.",
                pt: "Os quiropraxistas utilizam ajustes precisos para corrigir subluxações (desalinhamentos vertebrais) que podem interferir na transmissão adequada dos impulsos nervosos, afetando a saúde geral do corpo. Estes ajustes ajudam a aliviar dores, melhorar a mobilidade e restaurar a função normal do sistema nervoso."
            },
            description2: {
                en: "In our clinic, Chiropractic is applied by highly qualified professionals who use safe and effective techniques to treat a variety of conditions, from lumbar and cervical pain to posture problems and sports injuries.",
                pt: "Na nossa clínica, a Quiropraxia é aplicada por profissionais altamente qualificados, que utilizam técnicas seguras e eficazes para tratar uma variedade de condições, desde dores lombares e cervicais até problemas de postura e lesões esportivas."
            },
            firstConsultInfo: {
                en: "The first consultation includes a complete assessment, postural examination, and the first chiropractic adjustments.",
                pt: "A primeira consulta inclui avaliação completa, exame postural e os primeiros ajustes quiropráticos."
            }
        },
        cuppingTherapy: {
            title: {
                en: "Cupping Therapy",
                pt: "Ventosaterapia"
            },
            description1: {
                en: "Cupping Therapy, also known as Ventosaterapia, is an ancient technique from traditional Chinese medicine that uses suction cups to improve blood circulation, relieve muscle pain, and promote relaxation. This technique gained worldwide popularity after being seen on Olympic athletes and celebrities.",
                pt: "A Ventosaterapia, também conhecida como Terapia das Ventosas ou Cupping Therapy, é uma técnica milenar da medicina tradicional chinesa que utiliza copos de sucção para melhorar a circulação sanguínea, aliviar dores musculares e promover relaxamento. Esta técnica ganhou popularidade mundial após ser vista em atletas olímpicos e celebridades."
            },
            howItWorksTitle: {
                en: "How Does It Work?",
                pt: "Como Funciona?"
            },
            howItWorksDescription: {
                en: "The technique consists of applying glass, silicone, or acrylic cups to the skin, creating a vacuum that causes suction. This suction:",
                pt: "A técnica consiste na aplicação de copos de vidro, silicone ou acrílico sobre a pele, criando vácuo que provoca sucção. Esta sucção:"
            },
            howItWorksList: {
                bloodFlow: {
                    en: "Increases blood flow in the area",
                    pt: "Aumenta o fluxo sanguíneo na área"
                },
                toxinRelease: {
                    en: "Promotes the release of toxins",
                    pt: "Promove a liberação de toxinas"
                },
                muscleRelaxation: {
                    en: "Relaxes tense muscles",
                    pt: "Relaxa os músculos tensos"
                },
                lymphaticStimulation: {
                    en: "Stimulates the lymphatic system",
                    pt: "Estimula o sistema linfático"
                }
            },
            applicationTypesTitle: {
                en: "Types of Application",
                pt: "Tipos de Aplicação"
            },
            applicationTypes: {
                fixed: {
                    title: {
                        en: "Fixed Cupping",
                        pt: "Ventosa Fixa"
                    },
                    description: {
                        en: "Remains at a specific point for a few minutes",
                        pt: "Permanece em um ponto específico por alguns minutos"
                    }
                },
                sliding: {
                    title: {
                        en: "Sliding Cupping",
                        pt: "Ventosa Deslizante"
                    },
                    description: {
                        en: "Moved over the skin with oil for massage",
                        pt: "Movimentada sobre a pele com óleo para massagem"
                    }
                },
                flash: {
                    title: {
                        en: "Flash Cupping",
                        pt: "Ventosa Flash"
                    },
                    description: {
                        en: "Quick application and removal for stimulation",
                        pt: "Aplicação e remoção rápida para estimulação"
                    }
                }
            },
            benefitsTitle: {
                en: "Benefits of Cupping Therapy",
                pt: "Benefícios da Ventosaterapia"
            },
            benefits: {
                circulation: {
                    en: "Improved Circulation",
                    pt: "Melhora da Circulação"
                },
                painRelief: {
                    en: "Pain Relief",
                    pt: "Alívio de Dores"
                },
                detoxification: {
                    en: "Detoxification",
                    pt: "Desintoxicação"
                },
                respiratory: {
                    en: "Respiratory Improvement",
                    pt: "Melhora Respiratória"
                },
                immunity: {
                    en: "Strengthens Immunity",
                    pt: "Fortalece Imunidade"
                },
                stress: {
                    en: "Reduces Stress",
                    pt: "Reduz Estresse"
                }
            },
            sessionInfo: {
                en: "Cupping Therapy sessions last approximately 30-40 minutes. It is normal for the skin to show reddish circular marks after treatment, which disappear in a few days.",
                pt: "As sessões de Ventosaterapia duram aproximadamente 30-40 minutos. É normal que a pele apresente marcas circulares avermelhadas após o tratamento, que desaparecem em alguns dias."
            }
        },
        sportsMassage: {
            title: {
                en: "Sports Massage",
                pt: "Massagem Desportiva"
            },
            description1: {
                en: "Sports Massage is a specific technique developed for athletes and practitioners of physical activities. Different from conventional massages, it is focused on the preparation, maintenance, and recovery of the body for physical effort, helping to improve performance and prevent injuries.",
                pt: "A Massagem Desportiva é uma técnica específica desenvolvida para atletas e praticantes de atividades físicas. Diferente das massagens convencionais, ela é focada na preparação, manutenção e recuperação do corpo para o esforço físico, ajudando a melhorar o desempenho e prevenir lesões."
            },
            athleteBenefitsTitle: {
                en: "Benefits for Athletes",
                pt: "Benefícios para Atletas"
            },
            athleteBenefits: {
                acceleratedRecovery: {
                    title: {
                        en: "Accelerated Recovery",
                        pt: "Recuperação Acelerada"
                    },
                    description: {
                        en: "Reduction of muscle recovery time",
                        pt: "Redução do tempo de recuperação muscular"
                    }
                },
                injuryPrevention: {
                    title: {
                        en: "Injury Prevention",
                        pt: "Prevenção de Lesões"
                    },
                    description: {
                        en: "Reduces the risk of muscle injuries",
                        pt: "Reduz o risco de lesões musculares"
                    }
                },
                flexibility: {
                    title: {
                        en: "Flexibility",
                        pt: "Flexibilidade"
                    },
                    description: {
                        en: "Increased range of motion",
                        pt: "Aumento da amplitude de movimento"
                    }
                },
                circulation: {
                    title: {
                        en: "Circulation",
                        pt: "Circulação"
                    },
                    description: {
                        en: "Improved blood and lymphatic flow",
                        pt: "Melhoria do fluxo sanguíneo e linfático"
                    }
                }
            },
            description2: {
                en: "This massage modality works deeply in the muscles, improving blood circulation, accelerating muscle recovery, reducing tension, and preventing injuries. It is especially beneficial before and after intense physical activities, contributing to pre-workout muscle warm-up and post-workout lactic acid removal.",
                pt: "Esta modalidade de massagem trabalha profundamente na musculatura, melhorando a circulação sanguínea, acelerando a recuperação muscular, reduzindo a tensão e prevenindo lesões. É especialmente benéfica antes e após atividades físicas intensas, contribuindo para o aquecimento muscular pré-treino e para a remoção do ácido lático pós-treino."
            },
            description3: {
                en: "In our clinic, we offer Sports Massage sessions adapted to the specific needs of each athlete or physical activity practitioner. Our professionals are specialized in techniques that help improve flexibility, reduce muscle and joint pain, and promote faster recovery after intense training or competitions.",
                pt: "Na nossa clínica, oferecemos sessões de Massagem Desportiva adaptadas às necessidades específicas de cada atleta ou praticante de atividade física. Nossos profissionais são especializados em técnicas que ajudam a melhorar a flexibilidade, reduzir dores musculares e articulares, e promover uma recuperação mais rápida após treinos intensos ou competições."
            },
            sessionInfo: {
                en: "Sessions available in different durations: 30, 45, or 60 minutes, depending on the athlete's needs.",
                pt: "Sessões disponíveis em diferentes durações: 30, 45 ou 60 minutos, dependendo da necessidade do atleta."
            }
        },
        posturalAlignment: {
            title: {
                en: "Postural Alignment",
                pt: "Alinhamento Postural"
            },
            description1: {
                en: "Postural Alignment is a set of techniques and procedures aimed at correcting postural imbalances, improving body biomechanics, and preventing pain and injuries. This treatment is especially important for people who spend many hours in static positions, such as sitting in front of a computer, or who perform repetitive movements.",
                pt: "O Alinhamento Postural é um conjunto de técnicas e procedimentos que visam corrigir desequilíbrios posturais, melhorando a biomecânica do corpo e prevenindo dores e lesões. Este tratamento é especialmente importante para pessoas que passam muitas horas em posições estáticas, como sentadas em frente ao computador, ou que realizam movimentos repetitivos."
            },
            approachTitle: {
                en: "Our Approach to Postural Alignment",
                pt: "Nossa Abordagem para Alinhamento Postural"
            },
            approachDescription: {
                en: "Our methodology includes three main steps:",
                pt: "Nossa metodologia inclui três etapas principais:"
            },
            approachSteps: {
                detailedAssessment: {
                    en: "Detailed Assessment - Complete biomechanical analysis to identify postural imbalances and their causes",
                    pt: "Avaliação Detalhada - Análise biomecânica completa para identificar desequilíbrios posturais e suas causas"
                },
                personalizedTreatment: {
                    en: "Personalized Treatment - Combination of manual techniques, specific exercises, and ergonomic guidance",
                    pt: "Tratamento Personalizado - Combinação de técnicas manuais, exercícios específicos e orientações ergonômicas"
                },
                maintenancePrevention: {
                    en: "Maintenance and Prevention - Home exercise program and periodic follow-up",
                    pt: "Manutenção e Prevenção - Programa de exercícios para casa e acompanhamento periódico"
                }
            },
            benefitsTitle: {
                en: "Benefits of Postural Alignment",
                pt: "Benefícios do Alinhamento Postural"
            },
            benefits: {
                injuryPrevention: {
                    title: {
                        en: "Injury Prevention",
                        pt: "Prevenção de Lesões"
                    },
                    description: {
                        en: "Reduces the risk of musculoskeletal and degenerative injuries",
                        pt: "Reduz o risco de lesões musculoesqueléticas e degenerativas"
                    }
                },
                painRelief: {
                    title: {
                        en: "Pain Relief",
                        pt: "Alívio de Dores"
                    },
                    description: {
                        en: "Decreases chronic pain associated with postural problems",
                        pt: "Diminui dores crônicas associadas a problemas posturais"
                    }
                },
                moreEnergy: {
                    title: {
                        en: "More Energy",
                        pt: "Mais Energia"
                    },
                    description: {
                        en: "Improves movement efficiency and reduces energy expenditure",
                        pt: "Melhora a eficiência dos movimentos e reduz o gasto energético"
                    }
                }
            },
            description2: {
                en: "In our clinic, we use a combination of techniques such as Osteopathy, Chiropractic, GPR (Global Postural Reeducation), specific exercises, and ergonomic guidance to promote ideal postural alignment. Each program is personalized according to the needs and goals of each patient.",
                pt: "Em nossa clínica, utilizamos uma combinação de técnicas como Osteopatia, Quiropraxia, RPG (Reeducação Postural Global), exercícios específicos e orientações ergonômicas para promover o alinhamento postural ideal. Cada programa é personalizado de acordo com as necessidades e objetivos de cada paciente."
            },
            sessionInfo: {
                en: "The first consultation includes a complete postural assessment with biomechanical analysis and the beginning of treatment. The complete program usually involves 6 to 10 sessions, depending on the complexity of the case.",
                pt: "A primeira consulta inclui avaliação postural completa com análise biomecânica e início do tratamento. O programa completo geralmente envolve de 6 a 10 sessões, dependendo da complexidade do caso."
            }
        },
        painTreatment: {
            title: {
                en: "Pain Treatment",
                pt: "Tratamento da Dor"
            },
            description1: {
                en: "Pain Treatment is a multidisciplinary approach that combines different therapeutic techniques to relieve and manage acute and chronic pain. Our clinic offers a complete pain treatment program, personalized for each patient, aiming not only to relieve symptoms but also to identify and treat the underlying causes.",
                pt: "O Tratamento da Dor é uma abordagem multidisciplinar que combina diferentes técnicas terapêuticas para aliviar e gerenciar dores agudas e crônicas. Nossa clínica oferece um programa completo de tratamento da dor, personalizado para cada paciente, visando não apenas o alívio dos sintomas, mas também a identificação e tratamento das causas subjacentes."
            },
            painTypesTitle: {
                en: "Types of Pain We Treat",
                pt: "Tipos de Dor que Tratamos"
            },
            painTypes: {
                spine: {
                    en: "Spine pain (cervical, thoracic, and lumbar)",
                    pt: "Dores na coluna vertebral (cervical, torácica e lombar)"
                },
                joints: {
                    en: "Joint pain (shoulder, elbow, wrist, hip, knee, ankle)",
                    pt: "Dores articulares (ombro, cotovelo, punho, quadril, joelho, tornozelo)"
                },
                muscles: {
                    en: "Muscle pain and tendinitis",
                    pt: "Dores musculares e tendinites"
                },
                sports: {
                    en: "Pain related to sports injuries",
                    pt: "Dores relacionadas a lesões esportivas"
                },
                chronic: {
                    en: "Chronic pain and fibromyalgia",
                    pt: "Dores crônicas e fibromialgia"
                },
                headaches: {
                    en: "Headaches and migraines",
                    pt: "Cefaleias e enxaquecas"
                }
            },
            approachTitle: {
                en: "Our Approach",
                pt: "Nossa Abordagem"
            },
            approachDescription: {
                en: "We use a personalized combination of techniques, which may include:",
                pt: "Utilizamos uma combinação personalizada de técnicas, que podem incluir:"
            },
            techniques: {
                manualTherapy: {
                    en: "Manual Therapy",
                    pt: "Terapia Manual"
                },
                osteopathy: {
                    en: "Osteopathy",
                    pt: "Osteopatia"
                },
                chiropractic: {
                    en: "Chiropractic",
                    pt: "Quiropraxia"
                },
                acupuncture: {
                    en: "Acupuncture",
                    pt: "Acupuntura"
                },
                therapeuticExercises: {
                    en: "Therapeutic Exercises",
                    pt: "Exercícios Terapêuticos"
                },
                relaxationTechniques: {
                    en: "Relaxation Techniques",
                    pt: "Técnicas de Relaxamento"
                },
                myofascialRelease: {
                    en: "Myofascial Release",
                    pt: "Liberação Miofascial"
                },
                cuppingTherapy: {
                    en: "Cupping Therapy",
                    pt: "Ventosaterapia"
                }
            },
            description2: {
                en: "Our specialized team is ready to take care of your health.",
                pt: "A nossa equipa especializada está pronta para cuidar da sua saúde."
            },
            sessionInfo: {
                en: "The first consultation includes a complete assessment, diagnosis, and the beginning of treatment. The number of sessions needed varies according to each case.",
                pt: "A primeira consulta inclui avaliação completa, diagnóstico e início do tratamento. O número de sessões necessárias varia de acordo com cada caso."
            }
        },
        clinicalPilates: {
            title: {
                en: "Clinical Pilates with Equipment",
                pt: "Pilates Clínico com Aparelhos"
            },
            description1: {
                en: "Clinical Pilates is a fundamental method for pain stabilization and prevention of recurrences. Unlike conventional Pilates, Clinical Pilates is performed with specialized equipment and guided by health professionals who understand the biomechanics of the body and the specific needs of each patient.",
                pt: "O Pilates Clínico é um método fundamental na estabilização da dor e prevenção de recidivas. Diferente do Pilates convencional, o Pilates Clínico é realizado com aparelhos especializados e orientado por profissionais de saúde que compreendem a biomecânica do corpo e as necessidades específicas de cada paciente."
            },
            benefitsTitle: {
                en: "Benefits of Clinical Pilates",
                pt: "Benefícios do Pilates Clínico"
            },
            benefits: {
                painStabilization: {
                    en: "Pain Stabilization",
                    pt: "Estabilização da Dor"
                },
                controlledMovement: {
                    en: "Controlled Body Movement",
                    pt: "Movimento Controlado do Corpo"
                },
                flexibility: {
                    en: "Improved Flexibility",
                    pt: "Melhora da Flexibilidade"
                },
                spineStrength: {
                    en: "Strengthening of Spine-Supporting Muscles",
                    pt: "Fortalecimento de Músculos que Sustentam a Coluna"
                },
                recurrencePrevention: {
                    en: "Prevention of Pain Recurrences",
                    pt: "Prevenção de Recidivas da Dor"
                }
            },
            description2: {
                en: "Clinical Pilates promotes controlled body movement, works on flexibility, and strengthens the muscles that support the spine. It is an essential complement to manual therapy treatments, helping to maintain the results achieved during sessions.",
                pt: "O Pilates Clínico promove o movimento controlado do corpo, trabalha a flexibilidade e a força de músculos que sustentam a coluna vertebral. É um complemento essencial aos tratamentos de terapia manual, ajudando a manter os resultados alcançados durante as sessões."
            },
            sessionInfo: {
                en: "Clinical Pilates sessions are personalized and adapted to the needs of each patient, with equipment that allows safe and progressive exercises.",
                pt: "As sessões de Pilates Clínico são personalizadas e adaptadas às necessidades de cada paciente, com aparelhos que permitem exercícios seguros e progressivos."
            }
        }
    },

    // Contact Page
    contactPage: {
        hero: {
            title: {
                en: "Contact",
                pt: "Contacto"
            },
            subtitle: {
                en: "Want to know more about our services? Visit us or talk to us now.",
                pt: "Quer saber mais sobre os nossos serviços? Visite-nos ou fale já connosco."
            }
        },
        contactInfo: {
            title: {
                en: "Talk to Us",
                pt: "Fale Connosco"
            },
            subtitle: {
                en: "Our experience can make a difference in your daily life.",
                pt: "A nossa experiência pode fazer a diferença no seu dia-a-dia."
            },
            clinic: {
                name: {
                    en: "Clinic Dr. Guilherme Galvão",
                    pt: "Clínica Dr. Guilherme Galvão"
                }
            },
            address: {
                label: {
                    en: "Address",
                    pt: "Endereço"
                },
                value: {
                    en: "Av. Eng. Duarte Pacheco, 642\n4445-416 Ermesinde - Valongo",
                    pt: "Av. Eng. Duarte Pacheco, 642\n4445-416 Ermesinde - Valongo"
                },
                mapButton: {
                    en: "View on Google Maps",
                    pt: "Ver no Google Maps"
                }
            },
            schedule: {
                label: {
                    en: "Schedule",
                    pt: "Horário"
                },
                weekdays: {
                    label: {
                        en: "Mon-Fri",
                        pt: "Seg-Sex"
                    },
                    hours: {
                        en: "10:00h - 20:00h",
                        pt: "10:00h - 20:00h"
                    }
                },
                saturday: {
                    label: {
                        en: "Saturday",
                        pt: "Sábado"
                    },
                    hours: {
                        en: "8:00h - 12:00h",
                        pt: "8:00h - 12:00h"
                    }
                },
                sunday: {
                    label: {
                        en: "Sunday",
                        pt: "Domingo"
                    },
                    status: {
                        en: "Closed",
                        pt: "Encerrado"
                    }
                }
            },
            phone: {
                label: {
                    en: "Phone",
                    pt: "Telefone"
                },
                value: {
                    en: "(+351) 927 202 009",
                    pt: "(+351) 927 202 009"
                },
                note: {
                    en: "(Call to the national mobile network)",
                    pt: "(Chamada para a rede móvel nacional)"
                }
            },
            email: {
                label: {
                    en: "Email",
                    pt: "Email"
                },
                value: {
                    en: "info@clinicaosteopatia.pt",
                    pt: "info@clinicaosteopatia.pt"
                }
            },
            socialMedia: {
                label: {
                    en: "Follow Us",
                    pt: "Siga-nos"
                }
            }
        },
        contactForm: {
            title: {
                en: "Send Us a Message",
                pt: "Envie a sua mensagem"
            },
            fields: {
                name: {
                    label: {
                        en: "Name/Surname*",
                        pt: "Nome/Apelido*"
                    },
                    placeholder: {
                        en: "Name/Surname",
                        pt: "Nome/Apelido"
                    }
                },
                email: {
                    label: {
                        en: "Email*",
                        pt: "Email*"
                    },
                    placeholder: {
                        en: "Email",
                        pt: "Email"
                    }
                },
                phone: {
                    label: {
                        en: "Phone",
                        pt: "Telefone"
                    },
                    placeholder: {
                        en: "Phone",
                        pt: "Telefone"
                    }
                },
                subject: {
                    label: {
                        en: "Choose Subject*",
                        pt: "Escolher Assunto*"
                    },
                    options: {
                        appointment: {
                            en: "Schedule appointment",
                            pt: "Agendar consulta"
                        },
                        information: {
                            en: "Request information",
                            pt: "Pedir informação"
                        },
                        other: {
                            en: "Other Subject",
                            pt: "Outro Assunto"
                        }
                    }
                },
                timePreference: {
                    label: {
                        en: "Choose Schedule",
                        pt: "Escolher Horário"
                    },
                    placeholder: {
                        en: "Select a preference",
                        pt: "Selecione uma preferência"
                    },
                    options: {
                        morning: {
                            en: "Morning",
                            pt: "Manhã"
                        },
                        afternoon: {
                            en: "Afternoon",
                            pt: "Tarde"
                        }
                    }
                },
                message: {
                    label: {
                        en: "Message*",
                        pt: "Mensagem*"
                    },
                    placeholder: {
                        en: "Message",
                        pt: "Mensagem"
                    }
                },
                terms: {
                    label: {
                        en: "I accept Terms and Conditions*",
                        pt: "Aceito Termos e Condições*"
                    }
                },
                submitButton: {
                    en: "Send Message",
                    pt: "Enviar Mensagem"
                }
            },
            messages: {
                termsError: {
                    en: "You need to accept the terms and conditions.",
                    pt: "Você precisa aceitar os termos e condições."
                },
                generalError: {
                    en: "An error occurred. Please try again later.",
                    pt: "Ocorreu um erro. Por favor, tente novamente mais tarde."
                },
                success: {
                    en: "Your message has been sent successfully! We will contact you shortly.",
                    pt: "Sua mensagem foi enviada com sucesso! Entraremos em contato em breve."
                }
            }
        },
        map: {
            title: {
                en: "Location of the Clinic",
                pt: "Localização da Clínica"
            }
        },
        faq: {
            title: {
                en: "Frequently Asked Questions",
                pt: "Perguntas Frequentes"
            },
            subtitle: {
                en: "Answers to the most common questions",
                pt: "Respostas para as dúvidas mais comuns"
            },
            questions: [
                {
                    question: {
                        en: "How can I schedule an appointment?",
                        pt: "Como posso marcar uma consulta?"
                    },
                    answer: {
                        en: "You can schedule an appointment through our contact form on this page, by calling (+351) 927 202 009, or by sending an email to info@clinicaosteopatia.pt. We also accept in-person appointments at our clinic.",
                        pt: "Você pode marcar uma consulta através do nosso formulário de contacto nesta página, ligando para o número (+351) 927 202 009, ou enviando um email para info@clinicaosteopatia.pt. Também aceitamos marcações presenciais na nossa clínica."
                    }
                },
                {
                    question: {
                        en: "What is the average waiting time to get an appointment?",
                        pt: "Qual é o tempo médio de espera para conseguir uma consulta?"
                    },
                    answer: {
                        en: "We usually schedule appointments within 1 to 3 business days, depending on availability and urgency. For urgent cases, we always try to find a slot as soon as possible.",
                        pt: "Normalmente conseguimos agendar consultas dentro de 1 a 3 dias úteis, dependendo da disponibilidade e urgência. Para casos urgentes, tentamos sempre encontrar uma vaga o mais rápido possível."
                    }
                },
                {
                    question: {
                        en: "Do you accept health insurance?",
                        pt: "Aceitam seguros de saúde?"
                    },
                    answer: {
                        en: "Yes, we work with various insurance plans. Please contact us to check if your specific plan is accepted and which services are covered.",
                        pt: "Sim, trabalhamos com vários seguros e planos de saúde. Por favor, entre em contacto connosco para verificar se o seu plano específico é aceito e quais serviços são cobertos."
                    }
                },
                {
                    question: {
                        en: "What should I bring to the first appointment?",
                        pt: "O que devo trazer na primeira consulta?"
                    },
                    answer: {
                        en: "For the first appointment, we recommend bringing your ID, health insurance card (if applicable), and any medical exams or reports related to your condition. Wear comfortable clothes that allow movement.",
                        pt: "Para a primeira consulta, recomendamos trazer seu documento de identificação, cartão do seguro de saúde (se aplicável), e quaisquer exames médicos ou relatórios relacionados à sua condição. Use roupas confortáveis que permitam movimento."
                    }
                },
                {
                    question: {
                        en: "Is there parking near the clinic?",
                        pt: "Existe estacionamento próximo à clínica?"
                    },
                    answer: {
                        en: "Yes, we have parking available in the outdoor space next to the clinic, where you will easily find a place to park.",
                        pt: "Sim, temos estacionamento disponível no espaço exterior junto à clínica, onde você encontrará facilmente lugar para estacionar."
                    }
                }
            ]
        },
        cta: {
            title: {
                en: "Need specialized care?",
                pt: "Precisa de atendimento especializado?"
            },
            subtitle: {
                en: "Dedicated to your health with rigor and dedication.",
                pt: "Dedicado à sua saúde com rigor e dedicação."
            },
            button: {
                en: "Schedule Appointment",
                pt: "Marcar Consulta"
            }
        }
    },
    
    // Header
    header: {
        contact: {
            email: {
                en: "info@clinicaosteopatia.pt",
                pt: "info@clinicaosteopatia.pt"
            },
            phone: {
                en: "(+351) 927 202 009",
                pt: "(+351) 927 202 009"
            }
        },
        navigation: {
            home: {
                en: "Home",
                pt: "Início"
            },
            clinic: {
                title: {
                    en: "Clinic",
                    pt: "Clinica"
                },
                aboutUs: {
                    en: "About Us",
                    pt: "Sobre Nós"
                },
                gallery: {
                    en: "Gallery",
                    pt: "Galeria"
                },
                location: {
                    en: "Location",
                    pt: "Localização"
                },
                arbitration: {
                    en: "Arbitration",
                    pt: "Arbitragem"
                },
                termsConditions: {
                    en: "Terms and Conditions",
                    pt: "Termos e Condições"
                },
                privacyPolicy: {
                    en: "Privacy Policy",
                    pt: "Política de Privacidade"
                }
            },
            services: {
                title: {
                    en: "Services",
                    pt: "Serviços"
                },
                osteopathy: {
                    en: "Osteopathy",
                    pt: "Osteopatia"
                },
                physiotherapy: {
                    en: "Physiotherapy",
                    pt: "Fisioterapia"
                },
                chiropractic: {
                    en: "Chiropractic",
                    pt: "Quiropraxia"
                },
                sportsMassage: {
                    en: "Sports Massage",
                    pt: "Massagem Desportiva"
                },
                painTreatment: {
                    en: "Pain Treatment",
                    pt: "Tratamento da Dor"
                },
                auriculotherapy: {
                    en: "Auriculotherapy",
                    pt: "Auriculoterapia"
                },
                posturalAlignment: {
                    en: "Postural Alignment",
                    pt: "Alinhamento Postural"
                },
                cuppingTherapy: {
                    en: "Cupping Therapy",
                    pt: "Ventosaterapia"
                },
                clinicalPilates: {
                    en: "Clinical Pilates",
                    pt: "Pilates Clínico"
                }
            },
            contact: {
                en: "Contact",
                pt: "Contacto"
            }
        },
        appointmentButton: {
            en: "Schedule Appointment",
            pt: "Marcar Consulta"
        }
    },
    
    // Footer
    footer: {
        contact: {
            address: {
                line1: {
                    en: "Avenida Eng. Duarte Pacheco 642",
                    pt: "Avenida Eng. Duarte Pacheco 642"
                },
                line2: {
                    en: "Ermesinde, Portugal",
                    pt: "Ermesinde, Portugal"
                }
            },
            phone: {
                label: {
                    en: "Phone:",
                    pt: "Telefone:"
                },
                value: {
                    en: "(+351) 927 202 009",
                    pt: "(+351) 927 202 009"
                },
                note: {
                    en: "(Call to the national mobile network)",
                    pt: "(Chamada para a rede móvel nacional)"
                }
            },
            email: {
                label: {
                    en: "Email:",
                    pt: "Email:"
                },
                value: {
                    en: "info@clinicaosteopatia.pt",
                    pt: "info@clinicaosteopatia.pt"
                }
            }
        },
        links: {
            useful: {
                title: {
                    en: "Useful Links",
                    pt: "Links Úteis"
                },
                home: {
                    en: "Home",
                    pt: "Início"
                },
                aboutUs: {
                    en: "About Us",
                    pt: "Sobre Nós"
                },
                gallery: {
                    en: "Gallery",
                    pt: "Galeria"
                },
                location: {
                    en: "Location",
                    pt: "Localização"
                },
                arbitration: {
                    en: "Arbitration",
                    pt: "Arbitragem"
                }
            },
            services: {
                title: {
                    en: "Our Services",
                    pt: "Nossos Serviços"
                },
                osteopathy: {
                    en: "Osteopathy",
                    pt: "Osteopatia"
                },
                physiotherapy: {
                    en: "Physiotherapy",
                    pt: "Fisioterapia"
                },
                chiropractic: {
                    en: "Chiropractic",
                    pt: "Quiropraxia"
                },
                sportsMassage: {
                    en: "Sports Massage",
                    pt: "Massagem Desportiva"
                },
                painTreatment: {
                    en: "Pain Treatment",
                    pt: "Tratamento da Dor"
                }
            },
            moreServices: {
                title: {
                    en: "More Services",
                    pt: "Mais Serviços"
                },
                auriculotherapy: {
                    en: "Auriculotherapy",
                    pt: "Auriculoterapia"
                },
                posturalAlignment: {
                    en: "Postural Alignment",
                    pt: "Alinhamento Postural"
                },
                cuppingTherapy: {
                    en: "Cupping Therapy",
                    pt: "Ventosaterapia"
                },
                clinicalPilates: {
                    en: "Clinical Pilates",
                    pt: "Pilates Clínico"
                },
                appointment: {
                    en: "Schedule Appointment",
                    pt: "Marcar Consulta"
                }
            },
            legal: {
                title: {
                    en: "Legal",
                    pt: "Legal"
                },
                termsConditions: {
                    en: "Terms and Conditions",
                    pt: "Termos e Condições"
                },
                privacyPolicy: {
                    en: "Privacy Policy",
                    pt: "Política de Privacidade"
                }
            }
        },
        copyright: {
            text: {
                en: "© Copyright",
                pt: "© Copyright"
            },
            developedBy: {
                en: "Developed by",
                pt: "Desenvolvido por"
            },
            myouweb: {
                en: "MYOUWEB",
                pt: "MYOUWEB"
            },
            rights: {
                en: "All Rights Reserved",
                pt: "Todos os Direitos Reservados"
            },
            subtitle: {
                en: "Software & Digital Marketing",
                pt: "Software & Marketing Digital"
            }
        }
    }
};
